// Shared storefront analytics helpers for lead forms.
// Keep PII out of browser event parameters; form details still go to the form backend.
(function() {
  var META_PIXEL_ID_FALLBACK = "438417523799019";
  var GOOGLE_SUBMIT_LEAD_DESTINATION = "AW-621069237/z80pCOCEleUCELWHk6gC";
  var GOOGLE_QUIZ_COMPLETE_DESTINATION = "AW-621069237/JC50COrH-9ccELWHk6gC";
  var GOOGLE_QUIZ_EMAIL_SIGNUP_DESTINATION = "AW-621069237/aJvrCNTegtgcELWHk6gC";
  var GOOGLE_NEWSLETTER_SIGNUP_DESTINATION = "AW-621069237/pEf2CJSX7dccELWHk6gC";
  var GOOGLE_CUSTOM_DESIGN_DESTINATION = "AW-621069237/QkqeCMqK_9ccELWHk6gC";
  var LAST_LEAD_TRACKED_KEY = "ezup_last_lead_tracked_at";
  var ATTRIBUTION_STORAGE_KEY = "ezup_marketing_attribution_v1";
  var ATTRIBUTION_VERSION = "1";
  var ATTRIBUTION_PARAMETERS = [
    "gclid",
    "gbraid",
    "wbraid",
    "dclid",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_id",
    "utm_term",
    "utm_content"
  ];
  var customDesignSubmissions = {};

  function sendGoogleConversion(destination, payload, callback) {
    var completed = false;
    var finish = function() {
      if (completed) {
        return;
      }

      completed = true;

      if (typeof callback === "function") {
        callback();
      }
    };

    if (typeof window.gtag === "function") {
      var conversionPayload = Object.assign({
        send_to: destination,
        transport_type: "beacon"
      }, payload || {});

      if (typeof callback === "function") {
        conversionPayload.event_callback = finish;
      }

      window.gtag("event", "conversion", conversionPayload);

      if (typeof callback === "function") {
        window.setTimeout(finish, 1500);
      }
    } else {
      finish();
    }
  }

  function cleanPayload(payload) {
    var cleaned = {};

    Object.keys(payload || {}).forEach(function(key) {
      var value = payload[key];

      if (value === undefined || value === null || value === "") {
        return;
      }

      cleaned[key] = String(value);
    });

    return cleaned;
  }

  function detectMetaPixelId() {
    var scripts = document.querySelectorAll("script[src]");
    var patterns = [
      /\/signals\/config\/(\d+)/,
      /[?&]id=(\d+)/
    ];

    for (var i = 0; i < scripts.length; i++) {
      var src = scripts[i].src || "";

      if (src.indexOf("facebook") === -1 && src.indexOf("fbevents") === -1) {
        continue;
      }

      for (var j = 0; j < patterns.length; j++) {
        var match = src.match(patterns[j]);

        if (match && match[1]) {
          return match[1];
        }
      }
    }

    return META_PIXEL_ID_FALLBACK;
  }

  function appendMetaParam(params, key, value) {
    if (value === undefined || value === null || value === "") {
      return;
    }

    params.push(encodeURIComponent(key) + "=" + encodeURIComponent(String(value)));
  }

  function sendMetaLeadBeacon(payload, eventId) {
    var pixelId = detectMetaPixelId();

    if (!pixelId) {
      return;
    }

    var params = [];
    appendMetaParam(params, "id", pixelId);
    appendMetaParam(params, "ev", "Lead");
    appendMetaParam(params, "dl", window.location.href);
    appendMetaParam(params, "rl", document.referrer || "");
    appendMetaParam(params, "if", "false");
    appendMetaParam(params, "ts", Date.now());
    appendMetaParam(params, "eid", eventId);

    Object.keys(payload || {}).forEach(function(key) {
      appendMetaParam(params, "cd[" + key + "]", payload[key]);
    });

    var img = new Image(1, 1);
    img.style.display = "none";
    img.src = "https://www.facebook.com/tr/?" + params.join("&");

    if (document.body) {
      document.body.appendChild(img);
    }
  }

  function sendMetaCustomBeacon(eventName, payload, eventId) {
    var pixelId = detectMetaPixelId();

    if (!pixelId || !eventName) {
      return;
    }

    var params = [];
    appendMetaParam(params, "id", pixelId);
    appendMetaParam(params, "ev", eventName);
    appendMetaParam(params, "dl", window.location.href);
    appendMetaParam(params, "rl", document.referrer || "");
    appendMetaParam(params, "if", "false");
    appendMetaParam(params, "ts", Date.now());
    appendMetaParam(params, "eid", eventId);

    Object.keys(payload || {}).forEach(function(key) {
      appendMetaParam(params, "cd[" + key + "]", payload[key]);
    });

    var img = new Image(1, 1);
    img.style.display = "none";
    img.src = "https://www.facebook.com/tr/?" + params.join("&");

    if (document.body) {
      document.body.appendChild(img);
    }
  }

  function sendMetaStandardBeacon(eventName, payload, eventId) {
    var pixelId = detectMetaPixelId();

    if (!pixelId || !eventName) {
      return;
    }

    var params = [];
    appendMetaParam(params, "id", pixelId);
    appendMetaParam(params, "ev", eventName);
    appendMetaParam(params, "dl", window.location.href);
    appendMetaParam(params, "rl", document.referrer || "");
    appendMetaParam(params, "if", "false");
    appendMetaParam(params, "ts", Date.now());
    appendMetaParam(params, "eid", eventId);

    Object.keys(payload || {}).forEach(function(key) {
      appendMetaParam(params, "cd[" + key + "]", payload[key]);
    });

    var img = new Image(1, 1);
    img.style.display = "none";
    img.src = "https://www.facebook.com/tr/?" + params.join("&");

    if (document.body) {
      document.body.appendChild(img);
    }
  }

  function makeEventId(prefix) {
    return [
      prefix || "event",
      Date.now(),
      Math.random().toString(36).slice(2, 10)
    ].join("_");
  }

  function publishShopifyEvent(eventName, payload) {
    try {
      if (
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === "function"
      ) {
        window.Shopify.analytics.publish(eventName, payload);
      }
    } catch (error) {
      console.warn("Shopify analytics event failed:", error);
    }
  }

  var GA4_EVENT_NAMES = {
    CanopyQuizComplete: "quiz_complete",
    CanopyQuizEmailSignup: "quiz_email_signup",
    NewsletterSignup: "newsletter_signup",
    CustomDesignSubmitted: "custom_design_submitted",
    DesignTemplateDownload: "design_template_download",
    ProductDocumentDownload: "product_document_download",
    RequestQuote: "request_quote",
    QuoteCtaClick: "request_quote_cta_click",
    StoreDirectionsClick: "store_directions_click",
    BookAppointmentCtaClick: "book_appointment_cta_click",
    LiveChatOpen: "live_chat_open",
    EmailContactClick: "email_contact_click",
    PhoneLinkClick: "phone_click",
    CustomizeProductCtaClick: "customize_product_click",
    Schedule: "book_appointment"
  };

  function sendGa4Event(eventName, payload) {
    var ga4EventName = GA4_EVENT_NAMES[eventName] || eventName;

    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function() {
      window.dataLayer.push(arguments);
    };

    window.gtag("event", ga4EventName, payload || {});
  }

  function pushDataLayer(eventName, payload) {
    window.dataLayer = window.dataLayer || [];

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: eventName }, payload));
    }

    sendGa4Event(eventName, payload);
  }

  function readCookieValue(name) {
    var prefix = name + "=";
    var cookies = document.cookie ? document.cookie.split(";") : [];

    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim();

      if (cookie.indexOf(prefix) === 0) {
        try {
          return decodeURIComponent(cookie.slice(prefix.length));
        } catch (error) {
          return cookie.slice(prefix.length);
        }
      }
    }

    return "";
  }

  function readStoredAttribution() {
    try {
      return JSON.parse(window.sessionStorage.getItem(ATTRIBUTION_STORAGE_KEY) || "null") || {};
    } catch (error) {
      return {};
    }
  }

  function writeStoredAttribution(attribution) {
    try {
      window.sessionStorage.setItem(ATTRIBUTION_STORAGE_KEY, JSON.stringify(attribution));
    } catch (error) {
      // Attribution must never interfere with storefront behaviour.
    }
  }

  function readCurrentAttribution() {
    var params = new URLSearchParams(window.location.search);
    var touch = {
      landing_page_url: window.location.href,
      landing_page_path: window.location.pathname,
      referrer: document.referrer || "",
      captured_at: new Date().toISOString()
    };

    ATTRIBUTION_PARAMETERS.forEach(function(key) {
      var value = params.get(key);

      if (value) {
        touch[key] = value;
      }
    });

    return touch;
  }

  function hasMarketingAttribution(touch) {
    return ATTRIBUTION_PARAMETERS.some(function(key) {
      return Boolean(touch && touch[key]);
    });
  }

  function captureMarketingAttribution() {
    var stored = readStoredAttribution();
    var current = readCurrentAttribution();

    if (!stored.first_touch) {
      stored.first_touch = current;
    }

    if (hasMarketingAttribution(current)) {
      stored.last_touch = current;
    } else if (!stored.last_touch) {
      stored.last_touch = current;
    }

    stored.version = ATTRIBUTION_VERSION;
    writeStoredAttribution(stored);
    return stored;
  }

  function flattenAttribution(attribution) {
    var firstTouch = attribution.first_touch || {};
    var lastTouch = attribution.last_touch || {};
    var flattened = {
      attribution_version: attribution.version || ATTRIBUTION_VERSION,
      first_touch_landing_page_url: firstTouch.landing_page_url || "",
      first_touch_referrer: firstTouch.referrer || "",
      first_touch_captured_at: firstTouch.captured_at || "",
      last_touch_landing_page_url: lastTouch.landing_page_url || "",
      last_touch_referrer: lastTouch.referrer || "",
      last_touch_captured_at: lastTouch.captured_at || ""
    };

    ATTRIBUTION_PARAMETERS.forEach(function(key) {
      var value = lastTouch[key] || firstTouch[key] || "";

      if (value) {
        flattened[key] = value;
      }

      if (firstTouch[key]) {
        flattened["first_touch_" + key] = firstTouch[key];
      }

      if (lastTouch[key]) {
        flattened["last_touch_" + key] = lastTouch[key];
      }
    });

    return cleanPayload(flattened);
  }

  function enrichFormPayload(payload) {
    var enriched = payload && typeof payload === "object" ? payload : {};
    var attribution = captureMarketingAttribution();
    var flattened = flattenAttribution(attribution);

    Object.keys(flattened).forEach(function(key) {
      if (enriched[key] === undefined || enriched[key] === null || enriched[key] === "") {
        enriched[key] = flattened[key];
      }
    });

    var context = {};

    if (typeof enriched.hs_context === "string" && enriched.hs_context) {
      try {
        context = JSON.parse(enriched.hs_context) || {};
      } catch (error) {
        context = {};
      }
    } else if (enriched.hs_context && typeof enriched.hs_context === "object") {
      context = enriched.hs_context;
    }

    var hubspotVisitorToken = readCookieValue("hubspotutk");

    if (hubspotVisitorToken && !context.hutk) {
      context.hutk = hubspotVisitorToken;
    }

    context.pageUri = context.pageUri || enriched.source_page_url || window.location.href;
    context.pageName = context.pageName || document.title;
    enriched.hs_context = JSON.stringify(context);
    enriched.source_page_url = enriched.source_page_url || window.location.href;
    enriched.storefront_locale = enriched.storefront_locale ||
      (window.Shopify && window.Shopify.locale) || document.documentElement.lang || "";

    return enriched;
  }

  function isKnownFormEndpoint(input) {
    var rawUrl = typeof input === "string" ? input : input && input.url;

    if (!rawUrl) {
      return false;
    }

    try {
      var url = new URL(rawUrl, window.location.origin);
      var isShopifyFormsProxy = url.origin === window.location.origin &&
        url.pathname.indexOf("/apps/forms/") === 0 &&
        url.pathname !== "/apps/forms/views";
      var isLegacyFormHandler = url.hostname === "e-z-up-email-handler.fly.dev" &&
        url.pathname.indexOf("submit") !== -1 &&
        url.pathname.indexOf("form") !== -1;

      return isShopifyFormsProxy || isLegacyFormHandler;
    } catch (error) {
      return false;
    }
  }

  function installFormFetchEnrichment() {
    if (window.__ezupFormFetchEnrichmentInstalled || typeof window.fetch !== "function") {
      return;
    }

    var originalFetch = window.fetch.bind(window);
    window.__ezupFormFetchEnrichmentInstalled = true;

    window.fetch = function(input, init) {
      var requestInit = init;

      if (
        isKnownFormEndpoint(input) &&
        init &&
        (!init.method || String(init.method).toUpperCase() === "POST")
      ) {
        if (typeof init.body === "string") {
          try {
            var jsonPayload = JSON.parse(init.body);
            var viewId = window.EzupFormsAnalytics?.getViewId(input);
            if (viewId) jsonPayload._form_view_id = viewId;
            requestInit = Object.assign({}, init, {
              body: JSON.stringify(enrichFormPayload(jsonPayload))
            });
          } catch (error) {
            // Non-JSON form requests continue untouched.
          }
        } else if (typeof FormData !== "undefined" && init.body instanceof FormData) {
          var formData = init.body;
          var formViewId = window.EzupFormsAnalytics?.getViewId(input);
          if (formViewId) formData.set("_form_view_id", formViewId);
          var formPayload = enrichFormPayload({
            hs_context: formData.get("hs_context") || "",
            source_page_url: formData.get("source_page_url") || ""
          });

          Object.keys(formPayload).forEach(function(key) {
            var value = formPayload[key];

            if (value === undefined || value === null || value === "") {
              return;
            }

            if (key === "hs_context" || key === "source_page_url") {
              formData.set(key, String(value));
            } else if (!formData.has(key)) {
              formData.append(key, String(value));
            }
          });
        }
      }

      return originalFetch(input, requestInit);
    };
  }

  window.EzupAnalytics = window.EzupAnalytics || {};

  window.EzupAnalytics.getAttribution = function() {
    return flattenAttribution(captureMarketingAttribution());
  };

  window.EzupAnalytics.enrichFormPayload = enrichFormPayload;

  captureMarketingAttribution();
  installFormFetchEnrichment();

  window.EzupAnalytics.trackLead = function(payload, options) {
    var eventId = (options && options.eventId) || makeEventId("lead");
    var eventPayload = cleanPayload(payload || {});
    var sharedPayload = Object.assign({}, eventPayload, {
      event_id: eventId,
      meta_event_name: "Lead"
    });

    if (typeof window.fbq === "function") {
      try {
        window.fbq("track", "Lead", eventPayload, { eventID: eventId });
      } catch (error) {
        console.warn("Meta Lead event failed:", error);
        sendMetaLeadBeacon(eventPayload, eventId);
      }
    } else {
      sendMetaLeadBeacon(eventPayload, eventId);
    }

    pushDataLayer("generate_lead", sharedPayload);
    publishShopifyEvent("ezup_lead_submitted", sharedPayload);

    window.dispatchEvent(new CustomEvent("ezup:lead-submitted", {
      detail: sharedPayload
    }));

    try {
      window.sessionStorage.setItem(LAST_LEAD_TRACKED_KEY, String(Date.now()));
    } catch (storageError) {
      // Tracking must not block a successful form submission.
    }

    var redirectUrl = options && options.redirectUrl;
    sendGoogleConversion(
      GOOGLE_SUBMIT_LEAD_DESTINATION,
      {},
      redirectUrl ? function() { window.location.href = redirectUrl; } : null
    );

    return eventId;
  };

  window.EzupAnalytics.trackStandardEvent = function(eventName, payload, options) {
    var eventId = (options && options.eventId) || makeEventId(eventName || "standard");
    var eventPayload = cleanPayload(payload || {});
    var sharedPayload = Object.assign({}, eventPayload, {
      event_id: eventId,
      meta_event_name: eventName
    });

    if (typeof window.fbq === "function") {
      try {
        window.fbq("track", eventName, eventPayload, { eventID: eventId });
      } catch (error) {
        console.warn("Meta standard event failed:", error);
        sendMetaStandardBeacon(eventName, eventPayload, eventId);
      }
    } else {
      sendMetaStandardBeacon(eventName, eventPayload, eventId);
    }

    pushDataLayer(eventName, sharedPayload);
    publishShopifyEvent(eventName, sharedPayload);

    window.dispatchEvent(new CustomEvent("ezup:" + eventName, {
      detail: sharedPayload
    }));

    return eventId;
  };

  window.EzupAnalytics.trackCustomEvent = function(eventName, payload, options) {
    var eventId = (options && options.eventId) || makeEventId(eventName || "custom");
    var eventPayload = cleanPayload(payload || {});
    var sharedPayload = Object.assign({}, eventPayload, {
      event_id: eventId,
      meta_event_name: eventName
    });

    if (typeof window.fbq === "function") {
      try {
        window.fbq("trackCustom", eventName, eventPayload, { eventID: eventId });
      } catch (error) {
        console.warn("Meta custom event failed:", error);
        sendMetaCustomBeacon(eventName, eventPayload, eventId);
      }
    } else {
      sendMetaCustomBeacon(eventName, eventPayload, eventId);
    }

    pushDataLayer(eventName, sharedPayload);
    publishShopifyEvent(eventName, sharedPayload);

    window.dispatchEvent(new CustomEvent("ezup:" + eventName, {
      detail: sharedPayload
    }));

    return eventId;
  };

  window.EzupAnalytics.trackCustomDesignSubmitted = function(payload) {
    var eventPayload = Object.assign({
      content_category: "Custom Design",
      page_path: window.location.pathname,
      result_status: "backend_confirmed"
    }, payload || {});
    var signature = [
      eventPayload.source || "custom-central",
      eventPayload.variant_id || "",
      eventPayload.cart_line_key || "",
      eventPayload.file_name || ""
    ].join("|");

    if (customDesignSubmissions[signature]) {
      return customDesignSubmissions[signature];
    }

    var eventId = window.EzupAnalytics.trackCustomEvent(
      "CustomDesignSubmitted",
      eventPayload
    );

    customDesignSubmissions[signature] = eventId;
    sendGoogleConversion(GOOGLE_CUSTOM_DESIGN_DESTINATION, {
      value: 0.0,
      currency: "CAD"
    });

    return eventId;
  };

  (function setupCanopyQuizLeadTracking() {
    var QUIZ_PATH = "/pages/canopy-quiz";
    var RESULTS_PATHS = ["/pages/canopy-quiz-results", "/pages/quiz-results"];
    var ATTRIBUTION_KEY = "ezup_canopy_quiz_attribution";
    var PENDING_KEY = "ezup_canopy_quiz_lead_pending";
    var TRACKED_KEY = "ezup_canopy_quiz_lead_tracked";
    var COMPLETE_TRACKED_KEY = "ezup_canopy_quiz_complete_tracked";

    function normalizedPath() {
      var path = window.location.pathname.replace(/\/+$/, "");

      // Shopify prefixes translated storefront routes with the active locale
      // (for example /fr/pages/...). Conversion rules should use the same
      // canonical path in every market and language.
      return path.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i, "");
    }

    function isQuizPage() {
      return normalizedPath() === QUIZ_PATH;
    }

    function isResultsPage() {
      return RESULTS_PATHS.indexOf(normalizedPath()) !== -1;
    }

    function readUrlContext() {
      var params = new URLSearchParams(window.location.search);

      return {
        page_url: window.location.href,
        page_path: window.location.pathname,
        referrer: document.referrer || "",
        utm_source: params.get("utm_source") || "",
        utm_medium: params.get("utm_medium") || "",
        utm_campaign: params.get("utm_campaign") || "",
        utm_id: params.get("utm_id") || "",
        utm_content: params.get("utm_content") || "",
        utm_term: params.get("utm_term") || "",
        cq_attempt_id: params.get("cq_attempt_id") || params.get("c") || params.get("attempt") || params.get("attemptId") || "",
        cq_session_id: params.get("cq_session_id") || "",
        cq_quiz: params.get("cq_quiz") || "canopy-quiz",
        cq_result: params.get("top") || "",
        cq_email_subscribed: params.get("cq_email_subscribed") || "",
        timestamp: Date.now()
      };
    }

    function rememberQuizAttribution() {
      if (!isQuizPage()) {
        return;
      }

      try {
        sessionStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(readUrlContext()));
      } catch (error) {
        console.warn("Canopy quiz attribution storage failed:", error);
      }
    }

    function readStoredJson(key) {
      try {
        return JSON.parse(sessionStorage.getItem(key) || "null");
      } catch (error) {
        return null;
      }
    }

    function getQuizEmail(form) {
      var emailInput = form.querySelector('input[type="email"]');
      return emailInput ? emailInput.value.trim() : "";
    }

    function hasValidQuizEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    function trackQuizComplete() {
      if (!isResultsPage() || !window.EzupAnalytics || typeof window.EzupAnalytics.trackCustomEvent !== "function") {
        return;
      }

      var resultContext = readUrlContext();
      var attribution = readStoredJson(ATTRIBUTION_KEY) || {};

      if (!resultContext.cq_attempt_id) {
        return;
      }
      var completionKey = [
        resultContext.cq_attempt_id,
        resultContext.cq_session_id,
        resultContext.cq_result,
        window.location.pathname
      ].filter(Boolean).join("_");

      if (!completionKey) {
        completionKey = window.location.href;
      }

      if (sessionStorage.getItem(COMPLETE_TRACKED_KEY) === completionKey) {
        return;
      }

      var eventId = makeEventId("quiz_complete");
      var payload = Object.assign({}, attribution, resultContext, {
        content_name: "Canopy Quiz Complete",
        content_category: "Canopy Quiz",
        quiz_slug: resultContext.cq_quiz || attribution.cq_quiz || "canopy-quiz",
        quiz_result: resultContext.cq_result || attribution.cq_result || "",
        source_page_url: attribution.page_url || "",
        result_page_url: window.location.href,
        result_status: "success"
      });

      window.EzupAnalytics.trackCustomEvent("CanopyQuizComplete", payload, { eventId: eventId });
      sendGoogleConversion(GOOGLE_QUIZ_COMPLETE_DESTINATION, {
        value: 0.0,
        currency: "CAD"
      });
      sessionStorage.setItem(COMPLETE_TRACKED_KEY, completionKey);
    }

    function handleQuizEmailSubmit(event) {
      var form = event.target;

      if (!form || !form.classList || !form.classList.contains("peak-quiz-email-form")) {
        return;
      }

      var email = getQuizEmail(form);

      if (!hasValidQuizEmail(email)) {
        return;
      }

      var attribution = readStoredJson(ATTRIBUTION_KEY) || readUrlContext();
      var pendingLead = Object.assign({}, attribution, {
        event_id: makeEventId("quiz_lead"),
        form_id: "peak-quiz-email-form",
        form_endpoint: "/apps/canopy-quiz-api",
        source_page_url: attribution.page_url || window.location.href,
        timestamp: Date.now()
      });

      try {
        sessionStorage.setItem(PENDING_KEY, JSON.stringify(pendingLead));
      } catch (error) {
        console.warn("Canopy quiz lead storage failed:", error);
      }
    }

    function trackPendingQuizLead() {
      if (!isResultsPage() || !window.EzupAnalytics || typeof window.EzupAnalytics.trackCustomEvent !== "function") {
        return;
      }

      var pendingLead = readStoredJson(PENDING_KEY);

      if (!pendingLead || !pendingLead.event_id) {
        return;
      }

      var age = Date.now() - Number(pendingLead.timestamp || 0);

      if (age > 30 * 60 * 1000) {
        sessionStorage.removeItem(PENDING_KEY);
        return;
      }

      if (sessionStorage.getItem(TRACKED_KEY) === pendingLead.event_id) {
        return;
      }

      var resultContext = readUrlContext();

      if (resultContext.cq_email_subscribed !== "1" || !resultContext.cq_attempt_id) {
        return;
      }

      var payload = Object.assign({}, pendingLead, {
        content_name: "Canopy Quiz Lead",
        content_category: "Canopy Quiz",
        lead_type: "quiz_email_gate",
        quiz_slug: pendingLead.cq_quiz || resultContext.cq_quiz || "canopy-quiz",
        quiz_result: resultContext.cq_result || pendingLead.cq_result || "",
        cq_attempt_id: resultContext.cq_attempt_id || pendingLead.cq_attempt_id || "",
        cq_session_id: resultContext.cq_session_id || pendingLead.cq_session_id || "",
        page_path: resultContext.page_path || pendingLead.page_path || "",
        result_page_url: window.location.href,
        source_page_url: pendingLead.source_page_url || pendingLead.page_url || "",
        result_status: "success"
      });

      window.EzupAnalytics.trackCustomEvent("CanopyQuizEmailSignup", payload, {
        eventId: pendingLead.event_id
      });
      sendGoogleConversion(GOOGLE_QUIZ_EMAIL_SIGNUP_DESTINATION, {
        value: 0.0,
        currency: "CAD"
      });
      sessionStorage.setItem(TRACKED_KEY, pendingLead.event_id);
      sessionStorage.removeItem(PENDING_KEY);
    }

    rememberQuizAttribution();
    trackQuizComplete();
    trackPendingQuizLead();

    document.addEventListener("submit", handleQuizEmailSubmit, true);

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function() {
        rememberQuizAttribution();
        trackQuizComplete();
        trackPendingQuizLead();
      });
    }
  })();

  (function setupNewsletterSignupTracking() {
    var PENDING_KEY = "ezup_newsletter_signup_pending";
    var TRACKED_KEY = "ezup_newsletter_signup_tracked";
    var MAX_AGE = 30 * 60 * 1000;

    function newsletterSource(form) {
      if (!form) {
        return "newsletter";
      }

      if (form.closest(".modal--newsletter, .popup-newsletter")) {
        return "popup";
      }

      if (form.closest("footer, .footer")) {
        return "footer";
      }

      if (form.closest(".announcement-bar__newsletter")) {
        return "announcement-bar";
      }

      if (form.closest(".blog-sidebar__item--newsletter")) {
        return "blog";
      }

      return form.id || "newsletter";
    }

    function isNewsletterForm(form) {
      if (!form || !form.querySelector('input[type="email"], input[name*="email" i]')) {
        return false;
      }

      var tags = form.querySelector('[name="contact[tags]"]');
      var identity = [
        form.id,
        form.className,
        form.getAttribute("action"),
        tags && tags.value
      ].join(" ").toLowerCase();

      return /newsletter|subscribe|sms-sign-up/.test(identity);
    }

    function trackNewsletterSignup(source, trackingSource) {
      var signature = [source || "newsletter", window.location.pathname].join("|");

      try {
        if (sessionStorage.getItem(TRACKED_KEY) === signature) {
          return;
        }
      } catch (storageError) {
        // Tracking should continue if storage is unavailable.
      }

      var eventId = makeEventId("newsletter_signup");
      var payload = {
        content_name: "Newsletter Signup",
        content_category: "Newsletter",
        signup_source: source || "newsletter",
        tracking_source: trackingSource || "confirmed_newsletter_signup",
        page_path: window.location.pathname,
        page_url: window.location.href,
        result_status: "success"
      };

      window.EzupAnalytics.trackCustomEvent("NewsletterSignup", payload, {
        eventId: eventId
      });
      sendGoogleConversion(GOOGLE_NEWSLETTER_SIGNUP_DESTINATION, {
        value: 0.0,
        currency: "CAD"
      });

      try {
        sessionStorage.setItem(TRACKED_KEY, signature);
      } catch (storageError) {
        // Tracking should never block the successful signup experience.
      }
    }

    document.addEventListener("newsletter:subscribed", function(event) {
      var detail = event.detail || {};

      if (detail.conversionConfirmed !== true) {
        return;
      }

      trackNewsletterSignup(
        detail.source || newsletterSource(event.target && event.target.querySelector("form")),
        "confirmed_custom_newsletter_endpoint"
      );
    });

    document.addEventListener("submit", function(event) {
      var form = event.target;

      if (!isNewsletterForm(form) || form.closest("newsletter-form")) {
        return;
      }

      try {
        sessionStorage.setItem(PENDING_KEY, JSON.stringify({
          event_id: makeEventId("newsletter_pending"),
          source: newsletterSource(form),
          timestamp: Date.now()
        }));
      } catch (storageError) {
        // Native Shopify newsletter submission must continue.
      }
    }, true);

    function consumeShopifyNewsletterSuccess() {
      if (new URLSearchParams(window.location.search).get("contact_posted") !== "true") {
        return;
      }

      var pending = null;

      try {
        pending = JSON.parse(sessionStorage.getItem(PENDING_KEY) || "null");
        sessionStorage.removeItem(PENDING_KEY);
      } catch (storageError) {
        return;
      }

      if (!pending || Date.now() - Number(pending.timestamp || 0) > MAX_AGE) {
        return;
      }

      trackNewsletterSignup(pending.source, "confirmed_shopify_newsletter_redirect");
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", consumeShopifyNewsletterSuccess);
    } else {
      consumeShopifyNewsletterSuccess();
    }
  })();
})();

(function setupUniversalLeadAndQuoteTracking() {
  if (document.querySelector('script[src*="ezup-ui-events.js"]')) {
    return;
  }

  if (window.__ezupUniversalLeadTrackingInstalled) {
    return;
  }

  window.__ezupUniversalLeadTrackingInstalled = true;

  var QUOTE_CTA_DESTINATION = "AW-621069237/nUbvCLizztccELWHk6gC";
  var PENDING_FORM_KEY = "ezup_pending_lead_form";
  var LAST_LEAD_TRACKED_KEY = "ezup_last_lead_tracked_at";
  var PENDING_MAX_AGE = 30 * 60 * 1000;
  var recentQuoteClick = { signature: "", time: 0 };
  var hubspotSubmissions = {};

  function cleanText(value) {
    return String(value || "").replace(/\s+/g, " ").trim();
  }

  function publishEvent(eventName, payload) {
    window.dataLayer = window.dataLayer || [];

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: eventName }, payload || {}));
    }

    sendGa4Event(eventName, payload || {});

    try {
      if (
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === "function"
      ) {
        window.Shopify.analytics.publish(eventName, payload || {});
      }
    } catch (error) {
      console.warn("Shopify analytics event failed:", error);
    }
  }

  function sendQuoteCtaConversion(element, text) {
    var href = element.href || element.getAttribute("href") || "";
    var signature = [window.location.pathname, href, text].join("|");
    var now = Date.now();

    if (signature === recentQuoteClick.signature && now - recentQuoteClick.time < 1500) {
      return;
    }

    recentQuoteClick = { signature: signature, time: now };

    var payload = {
      page_path: window.location.pathname,
      page_title: document.title,
      link_text: text,
      destination_url: href
    };

    publishEvent("request_quote_cta_click", payload);

    if (typeof window.gtag === "function") {
      window.gtag("event", "conversion", {
        send_to: QUOTE_CTA_DESTINATION,
        value: 0.0,
        currency: "CAD",
        transport_type: "beacon"
      });
    }
  }

  function isQuoteCta(element, text) {
    var href = String(element.href || element.getAttribute("href") || "").toLowerCase();
    var normalizedText = text.toLowerCase().replace(/[!?.]+$/g, "").trim();
    var hasQuoteTrigger = element.hasAttribute("data-quote-popup-trigger");
    var hasQuoteDestination = /\/(?:pages\/)?custom\/(?:quote|get-a-quote)(?:[/?#]|$)/.test(href) ||
      /\/pages\/custom-graphics(?:[/?#]|$)/.test(href) ||
      /#section-contact(?:$|[?&])/.test(href);
    var hasQuoteLabel = /^(?:get|request) (?:a )?quote$/.test(normalizedText) ||
      /^(?:demander|obtenir) (?:un |une )?(?:devis|soumission)$/.test(normalizedText);

    return hasQuoteTrigger || hasQuoteDestination || hasQuoteLabel;
  }

  function isNewsletterForm(form) {
    var tagsField = form.querySelector('[name="contact[tags]"]');
    var identity = [
      form.id,
      form.className,
      form.getAttribute("action"),
      tagsField && tagsField.value
    ].join(" ").toLowerCase();

    return /newsletter|subscribe|sms-sign-up|customer-login|create-customer|search-form/.test(identity);
  }

  function isLeadForm(form) {
    if (!form || isNewsletterForm(form)) {
      return false;
    }

    var hasEmail = !!form.querySelector('input[type="email"], input[name*="email" i]');
    var hasLeadDetail = !!form.querySelector(
      'textarea, input[type="tel"], input[name*="phone" i], input[name*="company" i], input[name*="message" i], input[name*="first" i], input[name*="last" i]'
    );

    return hasEmail && hasLeadDetail;
  }

  function isQuoteForm(form) {
    var identity = [
      form.id,
      form.className,
      form.getAttribute("action"),
      window.location.pathname
    ].join(" ").toLowerCase();

    return /quote-form|pdp_quote|custom\/quote|get-a-quote|custom-graphics/.test(identity);
  }

  function storePendingForm(form) {
    if (!isLeadForm(form)) {
      return;
    }

    var pending = {
      type: isQuoteForm(form) ? "quote" : "lead",
      time: Date.now(),
      form_id: form.id || "",
      form_class: cleanText(form.className),
      source_page: window.location.pathname
    };

    try {
      window.sessionStorage.setItem(PENDING_FORM_KEY, JSON.stringify(pending));
    } catch (storageError) {
      // Form submission must continue if storage is unavailable.
    }
  }

  function consumeSuccessfulRedirect() {
    var isThankYouPage = /\/pages\/thank-you\/?$/.test(window.location.pathname);
    var isShopifyContactSuccess = new URLSearchParams(window.location.search)
      .get("contact_posted") === "true";

    if (!isThankYouPage && !isShopifyContactSuccess) {
      return;
    }

    var pending;

    try {
      pending = JSON.parse(window.sessionStorage.getItem(PENDING_FORM_KEY) || "null");
      window.sessionStorage.removeItem(PENDING_FORM_KEY);
    } catch (storageError) {
      return;
    }

    if (!pending || Date.now() - Number(pending.time || 0) > PENDING_MAX_AGE) {
      return;
    }

    // Quote forms already fire the primary Request quote conversion after
    // backend success. Do not also count them as a generic lead.
    if (pending.type === "quote") {
      return;
    }

    var lastTrackedAt = 0;

    try {
      lastTrackedAt = Number(window.sessionStorage.getItem(LAST_LEAD_TRACKED_KEY) || 0);
    } catch (storageError) {
      lastTrackedAt = 0;
    }

    if (lastTrackedAt >= Number(pending.time || 0)) {
      return;
    }

    if (window.EzupAnalytics && typeof window.EzupAnalytics.trackLead === "function") {
      window.EzupAnalytics.trackLead({
        content_name: document.title || "Website Form",
        content_category: "Website Lead Form",
        form_id: pending.form_id,
        form_class: pending.form_class,
        source_page_path: pending.source_page,
        result_status: "success"
      });
    }
  }

  document.addEventListener("click", function(event) {
    var target = event.target;
    var element = target && typeof target.closest === "function"
      ? target.closest("a[href], button")
      : null;

    if (!element) {
      return;
    }

    var text = cleanText(element.textContent || element.getAttribute("aria-label"));

    if (isQuoteCta(element, text)) {
      sendQuoteCtaConversion(element, text);
    }
  }, true);

  document.addEventListener("submit", function(event) {
    storePendingForm(event.target);
  }, true);

  window.addEventListener("message", function(event) {
    var origin = String(event.origin || "");
    var data = event.data || {};

    if (!/(?:^|\.)hubspot\.com$|(?:^|\.)hsforms\.com$/.test(origin.replace(/^https?:\/\//, ""))) {
      return;
    }

    if (data.type !== "hsFormCallback" || data.eventName !== "onFormSubmitted") {
      return;
    }

    var formId = data.id || data.formGuid || "hubspot-form";

    if (hubspotSubmissions[formId]) {
      return;
    }

    hubspotSubmissions[formId] = true;

    if (window.EzupAnalytics && typeof window.EzupAnalytics.trackLead === "function") {
      window.EzupAnalytics.trackLead({
        content_name: document.title || "HubSpot Form",
        content_category: "Website Lead Form",
        form_id: formId,
        source_page_url: window.location.href,
        result_status: "success"
      });
    }
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", consumeSuccessfulRedirect);
  } else {
    consumeSuccessfulRedirect();
  }
})();

(function () {
  var pathname = window.location.pathname;
  var isProductPage = /^\/products\/[^/]+\/?$/.test(pathname);
  var isBrowsePage = /^\/collections(?:\/|$)/.test(pathname) || pathname === "/search";

  if (!isProductPage && !isBrowsePage) {
    return;
  }

  try {
    var currentUrl = new URL(window.location.href);
    var cleanUrl = currentUrl.pathname;
    var now = Date.now();

    if (isProductPage) {
      var selectedVariant = currentUrl.searchParams.get("variant");

      if (selectedVariant) {
        cleanUrl += "?variant=" + encodeURIComponent(selectedVariant);
      }

      var storedHistory = JSON.parse(
        localStorage.getItem("ezupRecentlyViewedProductUrls") || "[]"
      );
      var productHistory = Array.isArray(storedHistory) ? storedHistory : [];

      productHistory = productHistory.filter(function (entry) {
        return entry && entry.url && entry.url !== cleanUrl;
      });
      productHistory.unshift({ url: cleanUrl, viewedAt: now });

      localStorage.setItem(
        "ezupRecentlyViewedProductUrls",
        JSON.stringify(productHistory.slice(0, 20))
      );
      localStorage.setItem("lastViewedProductUrl", cleanUrl);
      return;
    }

    currentUrl.searchParams.delete("preview_theme_id");
    currentUrl.searchParams.delete("_fd");
    currentUrl.searchParams.delete("pb");
    cleanUrl = currentUrl.pathname + currentUrl.search + currentUrl.hash;

    localStorage.setItem(
      "ezupLastBrowseUrl",
      JSON.stringify({ url: cleanUrl, viewedAt: now })
    );
  } catch (error) {
    // Browsing history is an enhancement; navigation still falls back to home.
  }
})();

// Prevent duplicate cart change requests caused by multiple header sections
// each registering their own Cart handler on document.documentElement.
// When both fire on a single click, two sequential removals empty the cart.
(function() {
  var originalFetch = window.fetch;
  var cartChangeInProgress = false;

  window.fetch = function(url, options) {
    var urlStr = (url && typeof url === 'string') ? url : (url ? url.toString() : '');

    if (urlStr.indexOf('/cart/change') !== -1 && options && options.method === 'POST') {
      if (cartChangeInProgress) {
        return Promise.resolve(new Response('{"items":[],"item_count":0}', {
          status: 200,
          headers: new Headers({'Content-Type': 'application/json'})
        }));
      }

      cartChangeInProgress = true;
      return originalFetch.apply(this, arguments)['finally'](function() {
        cartChangeInProgress = false;
      });
    }

    return originalFetch.apply(this, arguments);
  };
})();

// Keep PDP variant changes from nudging the page position while media/price
// widgets refresh.
(function () {
  var pendingVariantScroll = null;

  function getScrollY() {
    return window.pageYOffset || document.documentElement.scrollTop || 0;
  }

  function getProductVariantScope(target) {
    if (!target || !target.closest) return null;

    return target.closest('[data-section-type="product"] .product-form__variants');
  }

  function rememberVariantScroll(target) {
    var scope = getProductVariantScope(target);

    if (!scope) return;

    pendingVariantScroll = {
      y: getScrollY(),
      at: Date.now(),
      canceled: false
    };
  }

  function restoreVariantScroll(expectedY) {
    if (!pendingVariantScroll || pendingVariantScroll.canceled) return;

    if (Math.abs(getScrollY() - expectedY) > 1) {
      window.scrollTo(window.pageXOffset || 0, expectedY);
    }
  }

  document.addEventListener('pointerdown', function (event) {
    rememberVariantScroll(event.target);
  }, true);

  document.addEventListener('keydown', function (event) {
    if ([' ', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(event.key) === -1) {
      return;
    }

    rememberVariantScroll(event.target);
  }, true);

  document.addEventListener('change', function (event) {
    if (pendingVariantScroll && Date.now() - pendingVariantScroll.at < 500) {
      return;
    }

    rememberVariantScroll(event.target);
  }, true);

  ['wheel', 'touchmove'].forEach(function (eventName) {
    window.addEventListener(eventName, function () {
      if (pendingVariantScroll) {
        pendingVariantScroll.canceled = true;
      }
    }, { passive: true });
  });

  document.addEventListener('variant:changed', function () {
    if (!pendingVariantScroll || Date.now() - pendingVariantScroll.at > 3000) {
      return;
    }

    var expectedY = pendingVariantScroll.y;

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        restoreVariantScroll(expectedY);
      });
    });

    setTimeout(function () {
      restoreVariantScroll(expectedY);
    }, 80);

    setTimeout(function () {
      restoreVariantScroll(expectedY);

      if (pendingVariantScroll && pendingVariantScroll.y === expectedY) {
        pendingVariantScroll = null;
      }
    }, 250);
  }, true);
})();

// Track drawer open state on <body> for mobile styling
(function () {
  var drawers = ['.mobile-menu', '.mini-cart'];
  var observer = new MutationObserver(function () {
    var anyOpen = drawers.some(function (sel) {
      var el = document.querySelector(sel);
      return el && el.getAttribute('aria-hidden') === 'false';
    });
    document.body.setAttribute('data-drawer-open', anyOpen ? 'true' : 'false');
  });

  function init() {
    drawers.forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) {
        observer.observe(el, { attributes: true, attributeFilter: ['aria-hidden'] });
      }
    });
    document.body.setAttribute('data-drawer-open', 'false');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// Remove duplicate Affirm promo rows when Shopify's async script loader
// injects the same widget multiple times after product price blocks.
(function () {
  var cleanupScheduled = false;

  function makeAffirmPromoInteractive(promo) {
    var modalTrigger = promo.querySelector('.affirm-modal-trigger');
    if (!modalTrigger) return;

    promo.classList.add('affirm-promo-clickable');
    promo.setAttribute('role', 'button');
    promo.setAttribute('tabindex', '0');
    promo.setAttribute(
      'aria-label',
      modalTrigger.getAttribute('aria-label') || modalTrigger.textContent.trim()
    );
    promo.style.cursor = 'pointer';
  }

  function openAffirmModal(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var promo = target.closest('.affirm-promo-clickable');
    if (!promo || target.closest('.affirm-modal-trigger')) return;

    var modalTrigger = promo.querySelector('.affirm-modal-trigger');
    if (modalTrigger) modalTrigger.click();
  }

  function openAffirmModalWithKeyboard(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    var promo = event.target.closest('.affirm-promo-clickable');
    if (!promo || event.target !== promo) return;

    event.preventDefault();
    var modalTrigger = promo.querySelector('.affirm-modal-trigger');
    if (modalTrigger) modalTrigger.click();
  }

  function dedupeAffirmPromos() {
    cleanupScheduled = false;

    if (document.body && document.body.classList.contains('template-cart')) {
      document.querySelectorAll('.affirm-as-low-as').forEach(function (promo) {
        promo.parentNode.removeChild(promo);
      });
      return;
    }

    if (document.querySelector('[data-product-template="custom-eclipse-max"]')) {
      document.querySelectorAll('.affirm-as-low-as').forEach(function (promo) {
        promo.parentNode.removeChild(promo);
      });
      return;
    }

    var priceBlocks = document.querySelectorAll('.product-unique-price');
    if (!priceBlocks.length) return;

    priceBlocks.forEach(function (priceBlock) {
      var sibling = priceBlock.nextElementSibling;
      var firstPromo = null;
      var hidePromos = priceBlock.classList.contains(
        'product-unique-price--hide-payment-terms'
      );

      while (
        sibling &&
        sibling.classList &&
        sibling.classList.contains('affirm-as-low-as')
      ) {
        var nextSibling = sibling.nextElementSibling;

        if (hidePromos) {
          sibling.parentNode.removeChild(sibling);
        } else if (!firstPromo) {
          firstPromo = sibling;
        } else {
          sibling.parentNode.removeChild(sibling);
        }

        sibling = nextSibling;
      }
    });

    document.querySelectorAll('.affirm-as-low-as').forEach(makeAffirmPromoInteractive);
  }

  function scheduleCleanup() {
    if (cleanupScheduled) return;
    cleanupScheduled = true;

    window.requestAnimationFrame(dedupeAffirmPromos);
  }

  function initAffirmCleanup() {
    scheduleCleanup();
    window.addEventListener('load', scheduleCleanup);
    document.addEventListener('variant:changed', scheduleCleanup);
    document.addEventListener('click', openAffirmModal);
    document.addEventListener('keydown', openAffirmModalWithKeyboard);

    var observer = new MutationObserver(scheduleCleanup);
    observer.observe(document.body, { childList: true, subtree: true });

    setTimeout(scheduleCleanup, 300);
    setTimeout(scheduleCleanup, 1200);
    setTimeout(scheduleCleanup, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAffirmCleanup);
  } else {
    initAffirmCleanup();
  }
})();

// Custom Central cart artwork state + cart-row upload flow.
(function () {
  var STORAGE_KEY = "ezup_custom_artwork_uploads_v1";
  var PENDING_KEY = "ezup_custom_artwork_pending_v1";
  var ENDPOINT = "/apps/forms/custom-central";

  function readJson(storage, key) {
    try {
      var raw = storage.getItem(key);
      return raw ? JSON.parse(raw) : {};
    } catch (error) {
      return {};
    }
  }

  function writeJson(storage, key, value) {
    try {
      storage.setItem(key, JSON.stringify(value));
    } catch (error) {
      window.console.warn("Unable to save Custom Central state", error);
    }
  }

  function getLineKey(row) {
    return row ? String(row.getAttribute("data-line-key") || "").trim() : "";
  }

  function getVariantId(row) {
    return row ? String(row.getAttribute("data-variant-id") || "").trim() : "";
  }

  function getLineStates() {
    return readJson(window.localStorage, STORAGE_KEY);
  }

  function saveLineStates(states) {
    writeJson(window.localStorage, STORAGE_KEY, states);
  }

  function getLineState(row) {
    var key = getLineKey(row);
    var states = getLineStates();
    return key && states[key] ? states[key] : null;
  }

  function setLineState(row, payload) {
    var key = getLineKey(row);
    if (!key) return;

    var states = getLineStates();
    states[key] = Object.assign({}, states[key] || {}, payload, {
      lineKey: key,
      variantId: getVariantId(row),
      productId: row.getAttribute("data-product-id") || "",
      productTitle: row.getAttribute("data-product-title") || "",
      sku: row.getAttribute("data-sku") || "",
      quantity: row.getAttribute("data-quantity") || "",
      updatedAt: Date.now()
    });
    saveLineStates(states);
  }

  function cleanupLineStates() {
    var rows = document.querySelectorAll("[data-custom-artwork-line]");
    if (!rows.length) return;

    var liveKeys = {};
    rows.forEach(function (row) {
      var key = getLineKey(row);
      if (key) liveKeys[key] = true;
    });

    var states = getLineStates();
    var changed = false;

    Object.keys(states).forEach(function (key) {
      if (!liveKeys[key]) {
        delete states[key];
        changed = true;
      }
    });

    if (changed) {
      saveLineStates(states);
    }
  }

  function getPendingUploads() {
    return readJson(window.sessionStorage, PENDING_KEY);
  }

  function savePendingUploads(pending) {
    writeJson(window.sessionStorage, PENDING_KEY, pending);
  }

  function getSelectedVariantId() {
    var form = document.querySelector('form[action*="/cart/add"]');
    var variantInput = form ? form.querySelector('[name="id"]') : null;
    if (!variantInput) {
      variantInput = document.querySelector('form[action*="/cart/add"] [name="id"], [name="id"]');
    }
    return variantInput ? String(variantInput.value || "").trim() : "";
  }

  function captureProductModalPending(dialog) {
    if (!dialog) return;

    var emailInput = dialog.querySelector("#email");
    var fileInput = dialog.querySelector("#logo");
    var variantId = getSelectedVariantId();
    var email = emailInput ? String(emailInput.value || "").trim() : "";
    var hasFile = !!(fileInput && fileInput.files && fileInput.files.length);
    var file = hasFile ? fileInput.files[0] : null;

    if (!variantId || (emailInput && !emailInput.checkValidity()) || (fileInput && !fileInput.checkValidity())) {
      return;
    }

    var pending = getPendingUploads();
    pending[variantId] = {
      uploaded: false,
      fileName: file ? file.name : "",
      email: email,
      source: "product-modal",
      updatedAt: Date.now()
    };
    savePendingUploads(pending);
  }

  function consumePendingUploads() {
    var rows = document.querySelectorAll("[data-custom-artwork-line]");
    if (!rows.length) return;

    var pending = getPendingUploads();
    var changed = false;

    rows.forEach(function (row) {
      var variantId = getVariantId(row);
      var pendingState = variantId ? pending[variantId] : null;
      var lineState = getLineState(row);

      if (!pendingState || lineState) return;

      setLineState(row, pendingState);
      delete pending[variantId];
      changed = true;
    });

    if (changed) {
      savePendingUploads(pending);
    }
  }

  function renderArtworkRow(row) {
    var state = getLineState(row);
    var label = row.querySelector("[data-cart-artwork-label]");
    var status = row.querySelector("[data-cart-artwork-status]");
    var uploaded = !!(state && state.uploaded);

    row.classList.toggle("is-uploaded", uploaded);

    if (label) {
      label.textContent = uploaded ? "Update your logo" : "Add your logo";
    }

    if (status) {
      status.hidden = !uploaded;
    }
  }

  function renderArtworkRows() {
    consumePendingUploads();
    cleanupLineStates();

    document.querySelectorAll("[data-custom-artwork-line]").forEach(function (row) {
      renderArtworkRow(row);
    });
  }

  function buildUploadFormData(row, file) {
    var state = getLineState(row) || {};
    var formData = new FormData();

    if (state.email) {
      formData.append("email", state.email);
    }

    formData.append("file", file);
    formData.append("file_name", file.name);
    formData.append("cart_line_key", getLineKey(row));
    formData.append("variant_id", getVariantId(row));
    formData.append("product_id", row.getAttribute("data-product-id") || "");
    formData.append("product_title", row.getAttribute("data-product-title") || "");
    formData.append("sku", row.getAttribute("data-sku") || "");
    formData.append("quantity", row.getAttribute("data-quantity") || "");
    formData.append("source", "cart-artwork-upload");
    formData.append("hs_context", JSON.stringify({
      pageUri: window.location.href,
      pageName: document.title
    }));

    return formData;
  }

  function submitCartArtwork(row, file) {
    var timeoutPromise = new Promise(function (_, reject) {
      window.setTimeout(function () {
        reject(new Error("Cart artwork upload timed out"));
      }, 10000);
    });

    return Promise.race([
      fetch(ENDPOINT, {
        method: "POST",
        body: buildUploadFormData(row, file),
        credentials: "same-origin"
      }),
      timeoutPromise
    ]).then(function (response) {
      if (!response || !response.ok) {
        throw new Error("Cart artwork upload failed with status " + (response ? response.status : "no response"));
      }

      return response.json();
    }).then(function (result) {
      if (!result || result.success !== true || result.conversion_confirmed !== true) {
        throw new Error("Cart artwork upload was not confirmed by the form handler");
      }

      return result;
    });
  }

  function handleCartArtworkChange(event) {
    var input = event.target && event.target.closest ? event.target.closest("[data-cart-artwork-input]") : null;
    if (!input || !input.files || !input.files.length) return;

    var row = input.closest("[data-custom-artwork-line]");
    var file = input.files[0];
    var label = row ? row.querySelector("[data-cart-artwork-label]") : null;

    if (!row || !file) return;

    row.classList.add("is-uploading");
    if (label) {
      label.textContent = "Uploading...";
    }

    submitCartArtwork(row, file).then(function () {
      setLineState(row, {
        uploaded: true,
        fileName: file.name,
        source: "cart-row"
      });

      document.dispatchEvent(new CustomEvent("custom-central:submitted", {
        detail: {
          conversionConfirmed: true,
          source: "cart-row",
          variantId: getVariantId(row),
          cartLineKey: getLineKey(row),
          fileName: file.name
        }
      }));
      renderArtworkRow(row);
    }).catch(function (error) {
      window.console.warn("Unable to upload cart artwork", error);
      window.alert("Unable to upload artwork. Please try again.");
      input.value = "";
      renderArtworkRow(row);
    }).finally(function () {
      row.classList.remove("is-uploading");
      input.value = "";
    });
  }

  document.addEventListener("click", function (event) {
    var proceed = event.target && event.target.closest ? event.target.closest("upload-logo-dialog #proceed") : null;
    if (proceed) {
      captureProductModalPending(proceed.closest("upload-logo-dialog"));
    }
  }, true);

  document.addEventListener("custom-central:submitted", function (event) {
    var detail = event.detail || {};

    if (detail.conversionConfirmed !== true) {
      return;
    }

    if (!detail.fileName) {
      return;
    }

    if (detail.source === "product-modal" && detail.variantId) {
      var pending = getPendingUploads();
      var pendingState = pending[detail.variantId] || {};
      pending[detail.variantId] = Object.assign({}, pendingState, {
        uploaded: !!detail.fileName,
        fileName: detail.fileName || pendingState.fileName || "",
        source: "product-modal",
        updatedAt: Date.now()
      });
      savePendingUploads(pending);
    }

    if (
      window.EzupAnalytics &&
      typeof window.EzupAnalytics.trackCustomDesignSubmitted === "function"
    ) {
      window.EzupAnalytics.trackCustomDesignSubmitted({
        source: detail.source || "custom-central",
        variant_id: detail.variantId || "",
        cart_line_key: detail.cartLineKey || "",
        file_name: detail.fileName || ""
      });
    }
  });

  document.addEventListener("change", handleCartArtworkChange);
  document.addEventListener("cart:rerendered", renderArtworkRows);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", renderArtworkRows);
  } else {
    renderArtworkRows();
  }
})();

// Guest + customer wishlist storefront controller.
(function () {
  var STORAGE_KEY = "ezupGuestWishlist.v1";
  var WISHLIST_TRANSLATIONS = {
    en: {
      addAllToCart: "Add All to Cart",
      addToCart: "Add to Cart",
      adding: "Adding...",
      emptyMessage: "This Wish List has no Items",
      openMyWishlist: "Open My Wish List",
      removeFromWishlist: "Remove from wishlist",
      signedInMessage: "Your signed-in wishlist lives in your account.",
      tryAgain: "Try Again"
    },
    fr: {
      addAllToCart: "Tout ajouter au panier",
      addToCart: "Ajouter au panier",
      adding: "Ajout...",
      emptyMessage: "Cette liste de souhaits ne contient aucun article",
      openMyWishlist: "Ouvrir ma liste de souhaits",
      removeFromWishlist: "Retirer de la liste de souhaits",
      signedInMessage: "Votre liste de souhaits connectée se trouve dans votre compte.",
      tryAgain: "Réessayer"
    }
  };

  function normalizeRootPrefix(value) {
    var rawValue = String(value || "").trim();

    if (!rawValue || rawValue === "/") {
      return "";
    }

    if (rawValue.charAt(0) !== "/") {
      rawValue = "/" + rawValue;
    }

    return rawValue.replace(/\/+$/, "");
  }

  function getStorefrontRootPrefix() {
    if (window.routes && typeof window.routes.rootUrlWithoutSlash === "string") {
      return normalizeRootPrefix(window.routes.rootUrlWithoutSlash);
    }

    if (window.routes && typeof window.routes.rootUrl === "string") {
      return normalizeRootPrefix(window.routes.rootUrl);
    }

    var firstPathSegment = String(window.location.pathname || "").split("/").filter(Boolean)[0] || "";
    return firstPathSegment.toLowerCase() === "fr" ? "/fr" : "";
  }

  function buildStorefrontPath(path) {
    var rootPrefix = getStorefrontRootPrefix();
    var normalizedPath = String(path || "");

    if (!normalizedPath) {
      return rootPrefix || "/";
    }

    if (/^https?:\/\//i.test(normalizedPath) || normalizedPath.indexOf("//") === 0) {
      return normalizedPath;
    }

    if (normalizedPath.charAt(0) !== "/") {
      normalizedPath = "/" + normalizedPath;
    }

    if (rootPrefix && normalizedPath.indexOf(rootPrefix + "/") !== 0 && normalizedPath !== rootPrefix) {
      return rootPrefix + normalizedPath;
    }

    return normalizedPath;
  }

  function normalizeLocale(value) {
    var languageCode = String(value || "")
      .trim()
      .toLowerCase()
      .replace(/_/g, "-")
      .split("-")[0];

    return /^[a-z]{2,3}$/.test(languageCode) ? languageCode : "";
  }

  function getStorefrontLocale() {
    var locale =
      normalizeLocale(document.documentElement.getAttribute("lang")) ||
      normalizeLocale(window.Shopify && window.Shopify.locale);

    if (locale) {
      return locale;
    }

    if (getStorefrontRootPrefix() === "/fr") {
      return "fr";
    }

    if (String(window.location.hostname || "").toLowerCase().endsWith(".fr")) {
      return "fr";
    }

    return "en";
  }

  function getWishlistCopy(key) {
    var locale = getStorefrontLocale();
    var copy = WISHLIST_TRANSLATIONS[locale] || WISHLIST_TRANSLATIONS.en;

    return copy[key] || WISHLIST_TRANSLATIONS.en[key] || "";
  }

  function translateWishlistOptionLabel(value) {
    if (getStorefrontLocale() !== "fr") {
      return value;
    }

    var labels = {
      "canopy size": "Taille de l’abri",
      "chair size": "Taille de chaise",
      color: "Couleur",
      "custom color": "Couleur personnalisée",
      size: "Taille",
      "top color": "Couleur du toit"
    };

    return labels[String(value || "").trim().toLowerCase()] || value;
  }

  function translateWishlistOptionValue(value) {
    if (getStorefrontLocale() !== "fr") {
      return value;
    }

    var values = {
      black: "Noir",
      blue: "Bleu",
      gray: "Gris",
      grey: "Gris",
      green: "Vert",
      orange: "Orange",
      red: "Rouge",
      white: "Blanc",
      yellow: "Jaune"
    };

    return values[String(value || "").trim().toLowerCase()] || value;
  }

  var PROXY_ROOT = buildStorefrontPath("/apps/guestwishlist/");
  var PROXY_API_ROOT = PROXY_ROOT.replace(/\/$/, "");
  var WISHLIST_PAGE_PATH = PROXY_ROOT;
  var relationshipBundleCache = {};
  var guestWishlistSnapshotCache = {};
  var guestWishlistHydrationRequest = null;
  var guestWishlistHydrationDone = false;
  var sharedWishlistMetaObserver = null;
  var wishlistMergeRedirectPending = false;
  var state = {
    signedIn: false,
    variantIds: [],
    count: 0,
    accountWishlistUrl: buildStorefrontPath("/account?view=wishlist"),
    loginUrl: buildStorefrontPath("/account/login") + "?return_url=" + encodeURIComponent(WISHLIST_PAGE_PATH)
  };
  var stateRequest = null;
  var initialized = false;

  function supportsStorage() {
    try {
      return typeof window.localStorage !== "undefined";
    } catch (error) {
      return false;
    }
  }

  function readGuestItems() {
    if (!supportsStorage()) return [];

    try {
      var rawValue = window.localStorage.getItem(STORAGE_KEY);
      var parsedValue = rawValue ? JSON.parse(rawValue) : [];

      if (!Array.isArray(parsedValue)) {
        return [];
      }

      return parsedValue
        .map(function (item) {
          if (!item || !item.variantId) return null;

          return {
            variantId: String(item.variantId),
            productId: item.productId ? String(item.productId) : "",
            productTitle: item.productTitle ? String(item.productTitle) : "",
            productUrl: item.productUrl ? String(item.productUrl) : "",
            variantTitle: item.variantTitle ? String(item.variantTitle) : "",
            sku: item.sku ? String(item.sku) : "",
            optionName: item.option1Name ? String(item.option1Name) : item.optionName ? String(item.optionName) : "",
            optionValue: item.option1Value ? String(item.option1Value) : item.optionValue ? String(item.optionValue) : "",
            option1Name: item.option1Name ? String(item.option1Name) : item.optionName ? String(item.optionName) : "",
            option1Value: item.option1Value ? String(item.option1Value) : item.optionValue ? String(item.optionValue) : "",
            option2Name: item.option2Name ? String(item.option2Name) : "",
            option2Value: item.option2Value ? String(item.option2Value) : "",
            option3Name: item.option3Name ? String(item.option3Name) : "",
            option3Value: item.option3Value ? String(item.option3Value) : "",
            cartVariantId: item.cartVariantId ? String(item.cartVariantId) : "",
            linkedVariantId: item.linkedVariantId ? String(item.linkedVariantId) : "",
            bundleProductTitle: item.bundleProductTitle ? String(item.bundleProductTitle) : "",
            bundleProductUrl: item.bundleProductUrl ? String(item.bundleProductUrl) : "",
            bundleVariantOptions: item.bundleVariantOptions ? String(item.bundleVariantOptions) : "",
            price: item.price ? String(item.price) : "",
            image: item.image ? String(item.image) : "",
            addedAt: item.addedAt ? String(item.addedAt) : ""
          };
        })
        .filter(Boolean);
    } catch (error) {
      return [];
    }
  }

  function writeGuestItems(items) {
    if (!supportsStorage()) return;

    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function clearGuestItems() {
    if (!supportsStorage()) return;

    window.localStorage.removeItem(STORAGE_KEY);
  }

  function getGuestWishlistRoot() {
    return document.querySelector("[data-guest-wishlist-root]");
  }

  function syncWishlistStateFromRoot() {
    var root = getGuestWishlistRoot();
    if (!root) return;

    var accountWishlistUrl = root.getAttribute("data-account-wishlist-url");
    var loginUrl = root.getAttribute("data-login-url");

    if (accountWishlistUrl) {
      state.accountWishlistUrl = accountWishlistUrl;
    }

    if (loginUrl) {
      state.loginUrl = loginUrl;
    }
  }

  function localizeWishlistStateUrls(nextState) {
    if (!nextState) {
      return nextState;
    }

    var wishlistUrl = buildStorefrontPath(nextState.wishlistUrl || "/apps/guestwishlist/");

    nextState.wishlistUrl = wishlistUrl;
    nextState.accountWishlistUrl = buildStorefrontPath(nextState.accountWishlistUrl || "/account?view=wishlist");
    nextState.loginUrl = buildStorefrontPath("/account/login") + "?return_url=" + encodeURIComponent(wishlistUrl);

    return nextState;
  }

  function getGuestVariantIds() {
    return readGuestItems()
      .map(function (item) {
        return item.variantId;
      })
      .filter(Boolean);
  }

  function isGuestWishlistPage() {
    return window.location.pathname.indexOf(WISHLIST_PAGE_PATH) === 0;
  }

  function isSharedGuestWishlistPage() {
    return window.location.pathname.indexOf(PROXY_ROOT + "shared") === 0;
  }

  function isAccountPage() {
    return window.location.pathname === buildStorefrontPath("/account");
  }

  function isAccountWishlistPage() {
    return isAccountPage() && window.location.search.indexOf("view=wishlist") !== -1;
  }

  function openGuestWishlistPage() {
    window.location.href = WISHLIST_PAGE_PATH;
  }

  function openAccountWishlistPage() {
    window.location.href = state.accountWishlistUrl;
  }

  function buildPreviewAwareUrl(pathOrUrl) {
    var requestUrl = new URL(pathOrUrl, window.location.origin);
    var currentUrl = new URL(window.location.href);
    var previewThemeId = currentUrl.searchParams.get("preview_theme_id");

    if (previewThemeId && !requestUrl.searchParams.has("preview_theme_id")) {
      requestUrl.searchParams.set("preview_theme_id", previewThemeId);
    }

    return requestUrl;
  }

  function buildBundleProperties(bundleData) {
    var properties = {};

    if (!bundleData) {
      return properties;
    }

    if (bundleData.mainProductTitle) {
      properties._bundle_product_title = bundleData.mainProductTitle;
    }

    if (bundleData.mainProductUrl) {
      properties._bundle_product_url = bundleData.mainProductUrl;
    }

    if (bundleData.mainVariantOptions && bundleData.mainVariantOptions !== "Default Title") {
      properties._bundle_variant_options = bundleData.mainVariantOptions;
    }

    return properties;
  }

  function getFakePropertiesManager() {
    return window.fakePropertiesManager
      && typeof window.fakePropertiesManager.setProperty === "function"
      ? window.fakePropertiesManager
      : null;
  }

  function syncFakePropertiesForVariant(variantId, fakeProperties) {
    var fakePropertiesManager = getFakePropertiesManager();

    if (!fakePropertiesManager || !variantId) {
      return;
    }

    if (typeof fakePropertiesManager.removePropertiesForVariant === "function") {
      fakePropertiesManager.removePropertiesForVariant(String(variantId));
    }

    (fakeProperties || []).forEach(function (property) {
      if (!property || !property.name) {
        return;
      }

      fakePropertiesManager.setProperty(
        String(variantId),
        property.name,
        property.value || ""
      );
    });
  }

  function getGuestItemOptionEntries(item) {
    if (!item) {
      return [];
    }

    var optionEntries = [
      {
        name: item.option1Name || item.optionName || "",
        value: item.option1Value || item.optionValue || ""
      },
      {
        name: item.option2Name || "",
        value: item.option2Value || ""
      },
      {
        name: item.option3Name || "",
        value: item.option3Value || ""
      }
    ];

    return optionEntries.filter(function (entry) {
      return entry.name && entry.value && entry.value !== "Default Title";
    });
  }

  function parseSharedWishlistOptionEntries(optionText) {
    var normalizedOptionText = String(optionText || "").trim();
    if (!normalizedOptionText) {
      return [];
    }

    return normalizedOptionText
      .split(/\s+\|\s+/)
      .map(function (segment) {
        var rawSegment = String(segment || "").trim();
        if (!rawSegment) {
          return null;
        }

        var separatorIndex = rawSegment.indexOf(":");
        if (separatorIndex === -1) {
          return null;
        }

        var name = rawSegment.slice(0, separatorIndex).trim();
        var value = rawSegment.slice(separatorIndex + 1).trim();

        if (!name || !value || value === "Default Title") {
          return null;
        }

        return {
          name: name,
          value: value
        };
      })
      .filter(Boolean);
  }

  function getGuestItemOptionsLabel(item) {
    var optionValues = getGuestItemOptionEntries(item).map(function (entry) {
      return entry.value;
    }).filter(Boolean);

    if (optionValues.length) {
      return optionValues.join(" / ");
    }

    var fallbackValue = item && (item.variantTitle || item.optionValue || "");
    return fallbackValue === "Default Title" ? "" : fallbackValue;
  }

  function getGuestItemFakeProperties(item) {
    var fakeProperties = [];

    if (!item) {
      return fakeProperties;
    }

    if (item.sku) {
      fakeProperties.push({
        name: "SKU",
        value: item.sku
      });
    }

    getGuestItemOptionEntries(item).forEach(function (entry) {
      fakeProperties.push({
        name: entry.name,
        value: entry.value
      });
    });

    return fakeProperties;
  }

  function preloadWishlistImage(src) {
    var imageSrc = String(src || "").trim();

    if (!imageSrc || typeof window.Image === "undefined") {
      return Promise.resolve();
    }

    return new Promise(function (resolve) {
      var image = new window.Image();

      image.onload = resolve;
      image.onerror = resolve;
      image.src = imageSrc;

      if (image.complete) {
        resolve();
      }
    });
  }

  function preloadGuestWishlistImages(items) {
    return Promise.all((items || []).map(function (item) {
      return preloadWishlistImage(item && item.image);
    }));
  }

  function mergeCartItems(items) {
    var mergedItems = [];
    var mergedLookup = {};

    (items || []).forEach(function (item) {
      if (!item || !item.id || !item.quantity) {
        return;
      }

      var mergeKey = JSON.stringify({
        id: Number(item.id) || 0,
        properties: item.properties || {}
      });

      if (!mergedLookup[mergeKey]) {
        mergedLookup[mergeKey] = {
          id: Number(item.id),
          quantity: 0
        };

        if (item.properties && Object.keys(item.properties).length) {
          mergedLookup[mergeKey].properties = Object.assign({}, item.properties);
        }

        mergedItems.push(mergedLookup[mergeKey]);
      }

      mergedLookup[mergeKey].quantity += Number(item.quantity) || 0;
    });

    return mergedItems;
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function getWishlistVisibleText(node) {
    if (!node) {
      return "";
    }

    var clone = node.cloneNode(true);
    Array.prototype.slice.call(clone.querySelectorAll(".visually-hidden")).forEach(function (hiddenNode) {
      if (hiddenNode.parentNode) {
        hiddenNode.parentNode.removeChild(hiddenNode);
      }
    });

    return clone.textContent.replace(/\s+/g, " ").trim();
  }

  function stripWishlistMarkup(value) {
    var rawValue = String(value || "").trim();

    if (!rawValue) {
      return "";
    }

    var decodedValue = rawValue;

    if (typeof document !== "undefined" && document.createElement) {
      var scratchNode = document.createElement("div");
      scratchNode.innerHTML = rawValue;
      decodedValue = String(scratchNode.textContent || scratchNode.innerText || "");
    }

    return decodedValue.replace(/<[^>]+>/g, " ");
  }

  function normalizeWishlistPrice(value) {
    return stripWishlistMarkup(value)
      .replace(/\bSale price\b/gi, "")
      .replace(/\bRegular price\b/gi, "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function formatWishlistMoney(cents) {
    if (
      typeof cents !== "number"
      || !isFinite(cents)
      || typeof Currency === "undefined"
      || !Currency
      || typeof Currency.formatMoney !== "function"
      || !window.theme
    ) {
      return "";
    }

    var currencyFormat = window.theme.currencyCodeEnabled
      ? window.theme.moneyWithCurrencyFormat
      : window.theme.moneyFormat;

    if (!currencyFormat) {
      return "";
    }

    return normalizeWishlistPrice(Currency.formatMoney(cents, currencyFormat));
  }

  function getImageUrlFromObject(imageObject) {
    if (!imageObject) {
      return "";
    }

    if (typeof imageObject === "string") {
      return String(imageObject).trim();
    }

    if (typeof imageObject.src === "string" && imageObject.src) {
      return String(imageObject.src).trim();
    }

    if (typeof imageObject.url === "string" && imageObject.url) {
      return String(imageObject.url).trim();
    }

    var previewImage = imageObject.preview_image || imageObject.previewImage || null;
    if (previewImage) {
      if (typeof previewImage.src === "string" && previewImage.src) {
        return String(previewImage.src).trim();
      }

      if (typeof previewImage.url === "string" && previewImage.url) {
        return String(previewImage.url).trim();
      }
    }

    return "";
  }

  function getVariantImageFromData(variant, productData) {
    if (!variant) {
      return "";
    }

    var directVariantImage = getImageUrlFromObject(
      variant.featured_media || variant.featured_image || variant.image
    );

    if (directVariantImage) {
      return directVariantImage;
    }

    var mediaId = "";

    if (variant.featured_media) {
      mediaId = String(
        typeof variant.featured_media === "object"
          ? (variant.featured_media.id || "")
          : variant.featured_media
      ).trim();
    } else if (variant.featured_image && typeof variant.featured_image === "object") {
      mediaId = String(variant.featured_image.id || "").trim();
    }

    if (mediaId && productData && Array.isArray(productData.media)) {
      for (var index = 0; index < productData.media.length; index += 1) {
        if (String(productData.media[index] && productData.media[index].id || "") === mediaId) {
          return getImageUrlFromObject(productData.media[index]);
        }
      }
    }

    return "";
  }

  function getWishlistProductImage(scope, variant) {
    var variantImage = getVariantImageFromData(variant);
    if (variantImage) {
      return variantImage;
    }

    var root = scope || document;
    var imageElement = null;
    var variantMediaId = variant && variant.featured_media && variant.featured_media.id
      ? String(variant.featured_media.id)
      : "";

    if (variantMediaId) {
      imageElement = root.querySelector(
        '.product-gallery__carousel-item[data-media-id="' + variantMediaId + '"] .product-gallery__image'
      );
    }

    if (!imageElement) {
      imageElement = root.querySelector(".product-gallery__carousel-item.is-selected .product-gallery__image");
    }

    if (!imageElement) {
      imageElement = root.querySelector(".product-gallery__image, .product-item__primary-image, .product-item__image-wrapper img");
    }

    if (!imageElement) {
      return "";
    }

    return String(
      imageElement.getAttribute("src")
      || imageElement.getAttribute("data-src")
      || imageElement.currentSrc
      || ""
    ).trim();
  }

  function getWishlistPriceText(scope, variant) {
    if (variant && variant.price != null) {
      var formattedVariantPrice = formatWishlistMoney(Number(variant.price));
      if (formattedVariantPrice) {
        return formattedVariantPrice;
      }
    }

    var root = scope || document;
    var priceNode = root.querySelector(
      ".product-unique-price .price--highlight, .product-unique-price .price:not(.price--compare):not(.total-price), .product-form .price--highlight, .price-list .price:not(.price--compare):not(.total-price)"
    );

    return normalizeWishlistPrice(getWishlistVisibleText(priceNode));
  }

  function getButtonVariantId(button) {
    return String(button.getAttribute("data-wishlist-variant-id") || "").trim();
  }

  function buildGuestItem(button) {
    var closestProductItem = button.closest(".product-item");
    var closestProductSection = button.closest(".product-form, .product-block-list, [data-section-type='product']");
    var productImage = closestProductItem
      ? closestProductItem.querySelector(".product-item__primary-image, .product-item__image-wrapper img")
      : null;
    var productTitleNode = closestProductItem
      ? closestProductItem.querySelector(".product-item__title")
      : (closestProductSection || document).querySelector("h1.product-meta__title, h1.product__title, h1");
    var productPriceNode = closestProductItem
      ? closestProductItem.querySelector(".price:not(.price--compare):not(.total-price), .product-item__price-list .price")
      : null;
    var currentPath = window.location.pathname + window.location.search;

    return {
      variantId: getButtonVariantId(button),
      productId: String(button.getAttribute("data-wishlist-product-id") || "").trim(),
      productTitle:
        String(button.getAttribute("data-wishlist-product-title") || "").trim() ||
        (productTitleNode ? productTitleNode.textContent.trim() : document.title),
      productUrl:
        String(button.getAttribute("data-wishlist-product-url") || "").trim() ||
        currentPath,
      sku: String(button.getAttribute("data-wishlist-sku") || "").trim(),
      variantTitle: String(button.getAttribute("data-wishlist-variant-title") || "").trim(),
      optionName:
        String(button.getAttribute("data-wishlist-option-name-1") || "").trim() ||
        String(button.getAttribute("data-wishlist-option-name") || "").trim(),
      optionValue:
        String(button.getAttribute("data-wishlist-option-value-1") || "").trim() ||
        String(button.getAttribute("data-wishlist-option-value") || "").trim(),
      option1Name:
        String(button.getAttribute("data-wishlist-option-name-1") || "").trim() ||
        String(button.getAttribute("data-wishlist-option-name") || "").trim(),
      option1Value:
        String(button.getAttribute("data-wishlist-option-value-1") || "").trim() ||
        String(button.getAttribute("data-wishlist-option-value") || "").trim(),
      option2Name: String(button.getAttribute("data-wishlist-option-name-2") || "").trim(),
      option2Value: String(button.getAttribute("data-wishlist-option-value-2") || "").trim(),
      option3Name: String(button.getAttribute("data-wishlist-option-name-3") || "").trim(),
      option3Value: String(button.getAttribute("data-wishlist-option-value-3") || "").trim(),
      price:
        normalizeWishlistPrice(String(button.getAttribute("data-wishlist-price") || "").trim()) ||
        (closestProductSection ? getWishlistPriceText(closestProductSection) : normalizeWishlistPrice(getWishlistVisibleText(productPriceNode))),
      image:
        String(button.getAttribute("data-wishlist-image") || "").trim() ||
        (closestProductSection ? getWishlistProductImage(closestProductSection) : (productImage ? productImage.getAttribute("src") || "" : "")),
      addedAt: new Date().toISOString()
    };
  }

  function getActiveVariantIds() {
    return state.signedIn ? state.variantIds || [] : getGuestVariantIds();
  }

  function setButtonState(button, isActive) {
    var defaultLabel = button.getAttribute("data-label-default") || "Add to Wish List";
    var activeLabel = button.getAttribute("data-label-active") || "Saved";
    var textNode = button.querySelector(".wishlist-trigger__text");

    button.classList.toggle("is-active", isActive);
    button.setAttribute("aria-pressed", isActive ? "true" : "false");
    button.setAttribute("aria-label", isActive ? activeLabel : defaultLabel);

    if (textNode) {
      textNode.textContent = isActive ? activeLabel : defaultLabel;
    }
  }

  function updateButtons() {
    var activeVariantIds = getActiveVariantIds();
    var activeSet = {};

    activeVariantIds.forEach(function (variantId) {
      activeSet[String(variantId)] = true;
    });

    document.querySelectorAll("[data-wishlist-trigger]").forEach(function (button) {
      setButtonState(button, Boolean(activeSet[getButtonVariantId(button)]));
    });
  }

  function findGuestItemIndex(items, variantId) {
    for (var index = 0; index < items.length; index += 1) {
      if (String(items[index].variantId) === String(variantId)) {
        return index;
      }
    }

    return -1;
  }

  function findGuestItemByVariantId(variantId) {
    var normalizedVariantId = String(variantId || "").trim();
    if (!normalizedVariantId) {
      return null;
    }

    var items = readGuestItems();

    for (var index = 0; index < items.length; index += 1) {
      if (String(items[index].variantId) === normalizedVariantId) {
        return items[index];
      }
    }

    return null;
  }

  function buildSharedWishlistItem(form) {
    if (!form) {
      return null;
    }

    var variantInput = form.querySelector('input[name="id"]');
    var row = form.closest(".shared-wishlist-table__row");
    var titleLink = row ? row.querySelector(".shared-wishlist-product__title") : null;
    var optionsNode = row ? row.querySelector(".shared-wishlist-product__options") : null;
    var priceNode = row ? row.querySelector(".shared-wishlist-product__price") : null;
    var imageNode = row ? row.querySelector(".shared-wishlist-product__media img") : null;
    var optionText = optionsNode ? optionsNode.textContent.trim() : "";
    var optionEntries = parseSharedWishlistOptionEntries(optionText);

    if (!variantInput || !variantInput.value) {
      return null;
    }

    return {
      variantId: String(variantInput.value || "").trim(),
      productId: "",
      productTitle: titleLink ? titleLink.textContent.trim() : document.title,
      productUrl: titleLink ? String(titleLink.getAttribute("href") || "").trim() : "",
      sku: "",
      variantTitle: !optionEntries.length && optionText !== "Default Title" ? optionText : "",
      optionName: optionEntries[0] ? optionEntries[0].name : "",
      optionValue: optionEntries[0] ? optionEntries[0].value : "",
      option1Name: optionEntries[0] ? optionEntries[0].name : "",
      option1Value: optionEntries[0] ? optionEntries[0].value : "",
      option2Name: optionEntries[1] ? optionEntries[1].name : "",
      option2Value: optionEntries[1] ? optionEntries[1].value : "",
      option3Name: optionEntries[2] ? optionEntries[2].name : "",
      option3Value: optionEntries[2] ? optionEntries[2].value : "",
      price: normalizeWishlistPrice(priceNode ? priceNode.textContent : ""),
      image: imageNode
        ? String(
          imageNode.getAttribute("src")
          || imageNode.getAttribute("data-src")
          || imageNode.currentSrc
          || ""
        ).trim()
        : "",
      addedAt: ""
    };
  }

  function applyCartItemToForm(form, cartItem) {
    if (!form || !cartItem) {
      return;
    }

    var variantInput = form.querySelector('input[name="id"]');
    var quantityInput = form.querySelector('input[name="quantity"]');

    if (variantInput) {
      variantInput.value = String(cartItem.id);
    }

    if (quantityInput) {
      quantityInput.value = String(cartItem.quantity || 1);
    }

    Array.prototype.slice.call(form.querySelectorAll('input[name^="properties["]')).forEach(function (input) {
      input.parentNode.removeChild(input);
    });

    if (!cartItem.properties) {
      return;
    }

    Object.keys(cartItem.properties).forEach(function (key) {
      var input = document.createElement("input");
      input.type = "hidden";
      input.name = "properties[" + key + "]";
      input.value = cartItem.properties[key];
      form.appendChild(input);
    });
  }

  function fetchRelationshipBundleData(productUrl, variantId, fallbackData) {
    if (!productUrl || !variantId) {
      return Promise.resolve(null);
    }

    var cacheKey = String(productUrl) + "::" + String(variantId);
    if (Object.prototype.hasOwnProperty.call(relationshipBundleCache, cacheKey)) {
      return Promise.resolve(relationshipBundleCache[cacheKey]);
    }

    var productRequestUrl = buildPreviewAwareUrl(productUrl);
    productRequestUrl.searchParams.set("variant", String(variantId));

    return window.fetch(productRequestUrl.toString(), {
      credentials: "same-origin",
      method: "GET"
    }).then(function (response) {
      if (!response.ok) {
        throw new Error("Unable to load relationship bundle data.");
      }

      return response.text();
    }).then(function (html) {
      var bundleDoc = new DOMParser().parseFromString(html, "text/html");
      var bundleElement = bundleDoc.querySelector("relationship-bundle");
      var linkedVariantId = parseInt(
        bundleElement ? bundleElement.getAttribute("linked-variant-id") || "" : "",
        10
      );

      if (!bundleElement || !linkedVariantId) {
        relationshipBundleCache[cacheKey] = null;
        return null;
      }

      var bundleData = {
        linkedVariantId: linkedVariantId,
        mainProductTitle: bundleElement.getAttribute("main-product-title")
          || fallbackData && fallbackData.title
          || "",
        mainProductUrl: bundleElement.getAttribute("main-product-url")
          || productUrl,
        mainVariantOptions: bundleElement.getAttribute("main-variant-options")
          || fallbackData && fallbackData.variantOptions
          || ""
      };

      if (bundleData.mainVariantOptions === "Default Title") {
        bundleData.mainVariantOptions = "";
      }

      relationshipBundleCache[cacheKey] = bundleData;
      return bundleData;
    }).catch(function (error) {
      console.error("Unable to resolve relationship bundle data for guest wishlist:", error);
      relationshipBundleCache[cacheKey] = null;
      return null;
    });
  }

  function buildGuestCartItemPayload(item, quantity) {
    if (!item || !quantity || !isFinite(quantity) || quantity < 1) {
      return Promise.resolve(null);
    }

    var originalVariantId = parseInt(item.variantId || "", 10);
    if (!originalVariantId) {
      return Promise.resolve(null);
    }

    var preResolvedCartVariantId = parseInt(item.cartVariantId || item.linkedVariantId || "", 10);
    var cartItem = {
      id: preResolvedCartVariantId || originalVariantId,
      quantity: quantity
    };

    if (preResolvedCartVariantId && preResolvedCartVariantId !== originalVariantId) {
      var preResolvedProperties = buildBundleProperties({
        mainProductTitle: item.bundleProductTitle || item.productTitle || "",
        mainProductUrl: item.bundleProductUrl || item.productUrl || "",
        mainVariantOptions: item.bundleVariantOptions || getGuestItemOptionsLabel(item)
      });

      if (Object.keys(preResolvedProperties).length) {
        cartItem.properties = preResolvedProperties;
      }

      return Promise.resolve({
        cartItem: cartItem,
        fakeProperties: getGuestItemFakeProperties(item)
      });
    }

    return fetchRelationshipBundleData(item.productUrl, originalVariantId, {
      title: item.productTitle || "",
      variantOptions: getGuestItemOptionsLabel(item)
    }).then(function (bundleData) {
      if (bundleData && bundleData.linkedVariantId) {
        cartItem.id = Number(bundleData.linkedVariantId);

        var bundleProperties = buildBundleProperties(bundleData);
        if (Object.keys(bundleProperties).length) {
          cartItem.properties = bundleProperties;
        }
      }

      return {
        cartItem: cartItem,
        fakeProperties: getGuestItemFakeProperties(item)
      };
    });
  }

  function fetchGuestWishlistSnapshot(productUrl, variantId) {
    if (!productUrl) {
      return Promise.resolve(null);
    }

    var cacheKey = String(productUrl) + "::snapshot::" + String(variantId || "");
    if (Object.prototype.hasOwnProperty.call(guestWishlistSnapshotCache, cacheKey)) {
      return Promise.resolve(guestWishlistSnapshotCache[cacheKey]);
    }

    var productRequestUrl = buildPreviewAwareUrl(productUrl);
    if (variantId) {
      productRequestUrl.searchParams.set("variant", String(variantId));
    }

    return window.fetch(productRequestUrl.toString(), {
      credentials: "same-origin",
      method: "GET"
    }).then(function (response) {
      if (!response.ok) {
        throw new Error("Unable to load wishlist product snapshot.");
      }

      return response.text();
    }).then(function (html) {
      var snapshotDoc = new DOMParser().parseFromString(html, "text/html");
      var productJsonNode = snapshotDoc.querySelector("script[data-product-json]");
      var productData = null;
      var productVariant = null;

      if (productJsonNode) {
        try {
          var parsedProductJson = JSON.parse(productJsonNode.textContent || "{}");
          productData = parsedProductJson && parsedProductJson.product ? parsedProductJson.product : null;

          if (productData && Array.isArray(productData.variants)) {
            for (var variantIndex = 0; variantIndex < productData.variants.length; variantIndex += 1) {
              if (String(productData.variants[variantIndex].id) === String(variantId)) {
                productVariant = productData.variants[variantIndex];
                break;
              }
            }
          }
        } catch (error) {
        }
      }

      var imageElement = snapshotDoc.querySelector(".product-gallery__carousel-item.is-selected .product-gallery__image")
        || snapshotDoc.querySelector(".product-gallery__image");
      var priceElement = snapshotDoc.querySelector(
        ".product-unique-price .price--highlight, .product-unique-price .price:not(.price--compare):not(.total-price)"
      );
      var snapshot = {
        image: getVariantImageFromData(productVariant, productData) || (
          imageElement
            ? String(
              imageElement.getAttribute("src")
              || imageElement.getAttribute("data-src")
              || imageElement.currentSrc
              || ""
            ).trim()
            : ""
        ),
        price: productVariant && productVariant.price != null
          ? (formatWishlistMoney(Number(productVariant.price)) || normalizeWishlistPrice(getWishlistVisibleText(priceElement)))
          : normalizeWishlistPrice(getWishlistVisibleText(priceElement))
      };

      guestWishlistSnapshotCache[cacheKey] = snapshot;
      return snapshot;
    }).catch(function (error) {
      console.error("Unable to hydrate guest wishlist snapshot:", error);
      guestWishlistSnapshotCache[cacheKey] = null;
      return null;
    });
  }

  function hydrateGuestWishlistItems() {
    if (guestWishlistHydrationDone || guestWishlistHydrationRequest || state.signedIn || !isGuestWishlistPage()) {
      return;
    }

    var items = readGuestItems();
    if (!items.length) {
      guestWishlistHydrationDone = true;
      return;
    }

    guestWishlistHydrationRequest = Promise.all(items.map(function (item) {
      return fetchGuestWishlistSnapshot(item.productUrl, item.variantId);
    }))
      .then(function (snapshots) {
        var changed = false;
        var nextItems = items.map(function (item, index) {
          var nextItem = Object.assign({}, item);
          var snapshot = snapshots[index];
          var normalizedStoredPrice = normalizeWishlistPrice(nextItem.price);

          if (normalizedStoredPrice !== nextItem.price) {
            nextItem.price = normalizedStoredPrice;
            changed = true;
          }

          if (snapshot && snapshot.image && snapshot.image !== nextItem.image) {
            nextItem.image = snapshot.image;
            changed = true;
          }

          if (snapshot && snapshot.price && snapshot.price !== nextItem.price) {
            nextItem.price = snapshot.price;
            changed = true;
          }

          return nextItem;
        });

        guestWishlistHydrationDone = true;

        if (changed) {
          writeGuestItems(nextItems);
          preloadGuestWishlistImages(nextItems).then(function () {
            renderGuestWishlistPage();
          });
        }
      })
      .catch(function () {
        guestWishlistHydrationDone = true;
      })
      .finally(function () {
        guestWishlistHydrationRequest = null;
      });
  }

  function getRenderedGuestWishlistVariantIds(root) {
    if (!root) {
      return [];
    }

    return Array.prototype.slice.call(root.querySelectorAll("[data-guest-wishlist-item]"))
      .map(function (card) {
        return String(card.getAttribute("data-guest-wishlist-variant-id") || "").trim();
      })
      .filter(Boolean);
  }

  function guestWishlistCardsMatchItems(root, items) {
    var renderedVariantIds = getRenderedGuestWishlistVariantIds(root);

    if (renderedVariantIds.length !== items.length) {
      return false;
    }

    for (var index = 0; index < items.length; index += 1) {
      if (String(items[index].variantId) !== renderedVariantIds[index]) {
        return false;
      }
    }

    return true;
  }

  function patchGuestWishlistCard(card, item) {
    if (!card || !item) {
      return;
    }

    var productUrl = String(item.productUrl || "").trim();
    var productTitle = String(item.productTitle || "").trim();
    var imageSrc = String(item.image || "").trim();
    var mediaLink = card.querySelector(".guest-wishlist-card__media");
    var imageNode = mediaLink ? mediaLink.querySelector("img") : null;
    var cartForm = card.querySelector(".guest-wishlist-card__cart-form");
    var variantInput = cartForm ? cartForm.querySelector('input[name="id"]') : null;
    var titleLink = card.querySelector(".guest-wishlist-card__title");
    var detailsNode = card.querySelector(".guest-wishlist-card__details");
    var priceNode = card.querySelector(".guest-wishlist-card__price");
    var normalizedPrice = normalizeWishlistPrice(item.price);

    if (!mediaLink && imageSrc) {
      mediaLink = document.createElement("a");
      mediaLink.className = "guest-wishlist-card__media";

      imageNode = document.createElement("img");
      mediaLink.appendChild(imageNode);

      card.insertBefore(mediaLink, cartForm || detailsNode || null);
    }

    if (mediaLink && productUrl) {
      mediaLink.setAttribute("href", productUrl);
    }

    if (imageNode && imageSrc) {
      var currentImageSrc = String(imageNode.getAttribute("src") || imageNode.currentSrc || "").trim();

      if (currentImageSrc !== imageSrc) {
        imageNode.setAttribute("src", imageSrc);
      }

      imageNode.setAttribute("alt", productTitle);
    }

    if (cartForm) {
      cartForm.setAttribute("data-guest-wishlist-variant-id", String(item.variantId || ""));
    }

    if (variantInput) {
      variantInput.value = String(item.variantId || "");
    }

    if (titleLink) {
      if (productUrl) {
        titleLink.setAttribute("href", productUrl);
      }

      if (productTitle && titleLink.textContent !== productTitle) {
        titleLink.textContent = productTitle;
      }
    }

    if (!priceNode && normalizedPrice && detailsNode) {
      priceNode = document.createElement("div");
      priceNode.className = "guest-wishlist-card__price";
      detailsNode.insertBefore(priceNode, detailsNode.querySelector(".guest-wishlist-card__option") || null);
    }

    if (priceNode && normalizedPrice && priceNode.textContent !== normalizedPrice) {
      priceNode.textContent = normalizedPrice;
    }
  }

  function patchRenderedGuestWishlistPage(root, items) {
    if (!root || !guestWishlistCardsMatchItems(root, items)) {
      return false;
    }

    items.forEach(function (item) {
      var card = null;
      var cards = root.querySelectorAll("[data-guest-wishlist-item]");

      for (var index = 0; index < cards.length; index += 1) {
        if (String(cards[index].getAttribute("data-guest-wishlist-variant-id") || "") === String(item.variantId || "")) {
          card = cards[index];
          break;
        }
      }

      patchGuestWishlistCard(card, item);
    });

    return true;
  }

  function renderGuestWishlistPage() {
    var root = getGuestWishlistRoot();
    if (!root) return;

    if (wishlistMergeRedirectPending) {
      return;
    }

    if (state.signedIn) {
      root.innerHTML =
        '<section class="guest-wishlist-page guest-wishlist-page--signed-in">' +
        '<div class="guest-wishlist-empty">' +
        "<p>" + escapeHtml(getWishlistCopy("signedInMessage")) + "</p>" +
        '<p><a href="' + escapeHtml(state.accountWishlistUrl) + '">' + escapeHtml(getWishlistCopy("openMyWishlist")) + "</a></p>" +
        "</div>" +
        "</section>";
      return;
    }

    var items = readGuestItems();

    if (!items.length) {
      if (root.querySelector(".guest-wishlist-empty-notice")) {
        return;
      }

      root.innerHTML =
        '<section class="guest-wishlist-page guest-wishlist-page--empty">' +
        '<div class="guest-wishlist-empty-notice" role="status" aria-live="polite">' +
        '<span class="fa fa-flag" aria-hidden="true"></span>' +
        "<span>" + escapeHtml(getWishlistCopy("emptyMessage")) + "</span>" +
        "</div>" +
        "</section>";
      return;
    }

    if (patchRenderedGuestWishlistPage(root, items)) {
      hydrateGuestWishlistItems();
      return;
    }

    var cardsMarkup = items
      .map(function (item) {
        var imageMarkup = item.image
          ? '<a class="guest-wishlist-card__media" href="' +
            escapeHtml(item.productUrl) +
            '"><img src="' +
            escapeHtml(item.image) +
            '" alt="' +
            escapeHtml(item.productTitle) +
            '"></a>'
          : "";
        var optionEntries = getGuestItemOptionEntries(item);
        var variantMarkup = !optionEntries.length && item.variantTitle
          ? '<p class="guest-wishlist-card__variant">' + escapeHtml(item.variantTitle) + "</p>"
          : "";
        var optionMarkup = optionEntries
          .map(function (entry) {
            return (
              '<div class="guest-wishlist-card__option">' +
              '<div class="guest-wishlist-card__option-label">' + escapeHtml(translateWishlistOptionLabel(entry.name)) + "</div>" +
              '<div class="guest-wishlist-card__option-value">' + escapeHtml(translateWishlistOptionValue(entry.value)) + "</div>" +
              "</div>"
            );
          })
          .join("");
        var normalizedPrice = normalizeWishlistPrice(item.price);
        var priceMarkup = normalizedPrice
          ? '<div class="guest-wishlist-card__price">' + escapeHtml(normalizedPrice) + "</div>"
          : "";

        return (
          '<article class="guest-wishlist-card" data-guest-wishlist-item data-guest-wishlist-variant-id="' + escapeHtml(item.variantId) + '">' +
          '<button type="button" class="guest-wishlist-card__remove" data-wishlist-remove="' +
          escapeHtml(item.variantId) +
          '" aria-label="' + escapeHtml(getWishlistCopy("removeFromWishlist")) + '" title="' + escapeHtml(getWishlistCopy("removeFromWishlist")) + '">' +
          '<span class="fa fa-trash" aria-hidden="true"></span>' +
          "</button>" +
          imageMarkup +
          '<form class="guest-wishlist-card__cart-form" method="post" action="' + escapeHtml(window.routes && window.routes.cartAddUrl ? String(window.routes.cartAddUrl) : buildStorefrontPath("/cart/add")) + '" data-guest-wishlist-variant-id="' + escapeHtml(item.variantId) + '">' +
          '<input type="hidden" name="id" value="' + escapeHtml(item.variantId) + '">' +
          '<input type="hidden" name="quantity" value="1">' +
          '<button type="submit" class="guest-wishlist-card__button">' + escapeHtml(getWishlistCopy("addToCart")) + "</button>" +
          "</form>" +
          '<div class="guest-wishlist-card__details">' +
          '<a class="guest-wishlist-card__title" href="' +
          escapeHtml(item.productUrl) +
          '">' +
          escapeHtml(item.productTitle) +
          "</a>" +
          variantMarkup +
          priceMarkup +
          optionMarkup +
          "</div>" +
          "</article>"
        );
      })
      .join("");

    root.innerHTML =
      '<section class="guest-wishlist-page">' +
      '<div class="guest-wishlist-grid">' +
      cardsMarkup +
      "</div>" +
      '<div class="guest-wishlist-page__footer">' +
      '<button type="button" class="guest-wishlist-page__button" data-wishlist-add-all>' + escapeHtml(getWishlistCopy("addAllToCart")) + "</button>" +
      "</div>" +
      "</section>";

    hydrateGuestWishlistItems();
  }

  function applySharedWishlistMetaTitle(nextTitle) {
    if (!nextTitle) return;

    document.title = nextTitle;

    var titleTag = document.querySelector("title");
    if (titleTag) {
      titleTag.textContent = nextTitle;
    }

    document.querySelectorAll('meta[property="og:title"]').forEach(function (node) {
      node.setAttribute("content", nextTitle);
    });

    document.querySelectorAll('meta[name="twitter:title"]').forEach(function (node) {
      node.setAttribute("content", nextTitle);
    });

    document.querySelectorAll('meta[name="title"]').forEach(function (node) {
      node.setAttribute("content", nextTitle);
    });
  }

  function syncSharedWishlistMetaTitle() {
    if (!isSharedGuestWishlistPage()) return;

    var heroTitle = document.querySelector(".shared-wishlist-page__hero-title");
    var nextTitle = heroTitle ? String(heroTitle.textContent || "").trim() : "";

    if (nextTitle) {
      applySharedWishlistMetaTitle(nextTitle);
    }

    if (sharedWishlistMetaObserver || !document.body) {
      return;
    }

    sharedWishlistMetaObserver = new MutationObserver(function () {
      var nextHeroTitle = document.querySelector(".shared-wishlist-page__hero-title");
      var observedTitle = nextHeroTitle ? String(nextHeroTitle.textContent || "").trim() : "";

      if (!observedTitle) {
        return;
      }

      applySharedWishlistMetaTitle(observedTitle);
    });

    sharedWishlistMetaObserver.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function postCartItems(items) {
    var cartAddUrl = window.routes && window.routes.cartAddUrl
      ? String(window.routes.cartAddUrl)
      : "/cart/add";

    return window.fetch(cartAddUrl + ".js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      credentials: "same-origin",
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      if (!response.ok) {
        return response.json()
          .catch(function () {
            return null;
          })
          .then(function (errorPayload) {
            var message = errorPayload && errorPayload.description
              ? errorPayload.description
              : "Cart request failed with status " + response.status + ".";

            throw new Error(message);
          });
      }

      return response.json();
    });
  }

  function postJson(url, payload) {
    return window.fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      credentials: "same-origin",
      body: JSON.stringify(payload || {})
    }).then(function (response) {
      if (!response.ok) {
        throw new Error("Wishlist request failed with status " + response.status + ".");
      }

      return response.json();
    });
  }

  function fetchState() {
    return window.fetch(PROXY_API_ROOT + "/state", {
      method: "GET",
      headers: {
        Accept: "application/json"
      },
      credentials: "same-origin"
    }).then(function (response) {
      if (!response.ok) {
        throw new Error("Wishlist state request failed with status " + response.status + ".");
      }

      return response.json();
    });
  }

  function mergeGuestWishlist(serverState) {
    if (!serverState.signedIn) {
      return Promise.resolve(serverState);
    }

    var guestVariantIds = getGuestVariantIds();
    if (!guestVariantIds.length) {
      return Promise.resolve(serverState);
    }

    return postJson(PROXY_API_ROOT + "/merge", {
      variantIds: guestVariantIds
    }).then(function (response) {
      if (response && response.state) {
        response.state = localizeWishlistStateUrls(response.state);
        clearGuestItems();

        if (response.merged && (isGuestWishlistPage() || isAccountPage())) {
          wishlistMergeRedirectPending = true;
          window.location.replace(response.state.accountWishlistUrl || state.accountWishlistUrl);
        }

        return response.state;
      }

      return serverState;
    }).catch(function () {
      return serverState;
    });
  }

  function loadState() {
    if (stateRequest) {
      return stateRequest;
    }

    stateRequest = fetchState()
      .then(function (response) {
        if (response && response.ok && response.state) {
          return mergeGuestWishlist(response.state);
        }

        return state;
      })
      .then(function (nextState) {
        if (nextState) {
          state = localizeWishlistStateUrls(nextState);
        }

        if (!wishlistMergeRedirectPending) {
          updateButtons();
          renderGuestWishlistPage();
        }
        return state;
      })
      .catch(function () {
        if (!wishlistMergeRedirectPending) {
          updateButtons();
          renderGuestWishlistPage();
        }
        return state;
      })
      .finally(function () {
        stateRequest = null;
      });

    return stateRequest;
  }

  function toggleGuestWishlist(button) {
    var variantId = getButtonVariantId(button);
    if (!variantId) return;

    var items = readGuestItems();
    var existingIndex = findGuestItemIndex(items, variantId);

    if (existingIndex === -1) {
      items.push(buildGuestItem(button));
    } else if (isGuestWishlistPage()) {
      items.splice(existingIndex, 1);
    } else {
      openGuestWishlistPage();
      return;
    }

    guestWishlistHydrationDone = false;
    writeGuestItems(items);

    if (!isGuestWishlistPage()) {
      openGuestWishlistPage();
      return;
    }

    updateButtons();
    renderGuestWishlistPage();
  }

  function toggleCustomerWishlist(button) {
    var variantId = getButtonVariantId(button);
    if (!variantId) return;
    if (!isAccountWishlistPage() && button.classList.contains("is-active")) {
      openAccountWishlistPage();
      return;
    }

    button.disabled = true;

    postJson(PROXY_API_ROOT + "/toggle", {
      variantId: variantId
    })
      .then(function (response) {
        if (response && response.state) {
          state = response.state;
        }

        updateButtons();
        renderGuestWishlistPage();

        if (!isAccountWishlistPage()) {
          openAccountWishlistPage();
        }
      })
      .catch(function (error) {
        console.error(error);
      })
      .finally(function () {
        button.disabled = false;
      });
  }

  function handleWishlistClick(event) {
    var trigger = event.target.closest("[data-wishlist-trigger]");
    if (!trigger) return;

    event.preventDefault();

    if (stateRequest) {
      trigger.disabled = true;

      stateRequest.finally(function () {
        trigger.disabled = false;

        if (state.signedIn) {
          toggleCustomerWishlist(trigger);
        } else {
          toggleGuestWishlist(trigger);
        }
      });

      return;
    }

    if (state.signedIn) {
      toggleCustomerWishlist(trigger);
    } else {
      toggleGuestWishlist(trigger);
    }
  }

  function handleRemoveClick(event) {
    var removeButton = event.target.closest("[data-wishlist-remove]");
    if (!removeButton) return;

    event.preventDefault();

    var items = readGuestItems();
    var nextItems = items.filter(function (item) {
      return String(item.variantId) !== String(removeButton.getAttribute("data-wishlist-remove"));
    });

    guestWishlistHydrationDone = false;
    writeGuestItems(nextItems);
    updateButtons();
    renderGuestWishlistPage();
  }

  function handleGuestWishlistFormSubmit(event) {
    var form = event.target && event.target.closest
      ? event.target.closest(".guest-wishlist-card__cart-form")
      : null;

    var isSharedWishlistForm = false;

    if (!form) {
      form = event.target && event.target.closest
        ? event.target.closest(".shared-wishlist-action")
        : null;
      isSharedWishlistForm = Boolean(form);
    }

    if (!form) return;

    var resolvedAttributeName = isSharedWishlistForm
      ? "data-shared-wishlist-resolved"
      : "data-guest-wishlist-resolved";

    if (form.getAttribute(resolvedAttributeName) === "true") {
      form.removeAttribute(resolvedAttributeName);
      return;
    }

    event.preventDefault();

    var variantId = isSharedWishlistForm
      ? String((form.querySelector('input[name="id"]') || {}).value || "").trim()
      : String(form.getAttribute("data-guest-wishlist-variant-id") || "").trim();
    var item = isSharedWishlistForm
      ? buildSharedWishlistItem(form)
      : findGuestItemByVariantId(variantId);
    var submitButton = form.querySelector('button[type="submit"]');

    if (!item) {
      if (typeof HTMLFormElement !== "undefined" && HTMLFormElement.prototype.submit) {
        HTMLFormElement.prototype.submit.call(form);
      } else {
        form.submit();
      }
      return;
    }

    if (submitButton) {
      submitButton.disabled = true;
    }

    buildGuestCartItemPayload(item, 1)
      .then(function (payload) {
        if (!payload || !payload.cartItem) {
          throw new Error("Unable to build the wishlist cart payload.");
        }

        syncFakePropertiesForVariant(payload.cartItem.id, payload.fakeProperties);
        applyCartItemToForm(form, payload.cartItem);
        form.setAttribute(resolvedAttributeName, "true");

        if (typeof HTMLFormElement !== "undefined" && HTMLFormElement.prototype.submit) {
          HTMLFormElement.prototype.submit.call(form);
        } else {
          form.submit();
        }
      })
      .catch(function (error) {
        console.error(error);

        if (submitButton) {
          submitButton.disabled = false;
        }
      });
  }

  function handleAddAllToCart(event) {
    var addAllButton = event.target.closest("[data-wishlist-add-all]");
    if (!addAllButton) return;

    event.preventDefault();

    var guestItems = readGuestItems().filter(function (item) {
      return item && item.variantId;
    });

    if (!guestItems.length) return;

    var originalLabel = addAllButton.textContent;
    addAllButton.disabled = true;
    addAllButton.textContent = getWishlistCopy("adding");

    Promise.all(guestItems.map(function (item) {
      return buildGuestCartItemPayload(item, 1);
    }))
      .then(function (payloads) {
        var cartItems = payloads
          .filter(function (payload) {
            return payload && payload.cartItem;
          })
          .map(function (payload) {
            syncFakePropertiesForVariant(payload.cartItem.id, payload.fakeProperties);
            return payload.cartItem;
          });

        var mergedItems = mergeCartItems(cartItems);
        if (!mergedItems.length) {
          throw new Error("Unable to build guest wishlist cart items.");
        }

        return postCartItems(mergedItems);
      })
      .then(function () {
        window.location.href = buildPreviewAwareUrl(buildStorefrontPath("/cart")).toString();
      })
      .catch(function (error) {
        console.error(error);
        addAllButton.disabled = false;
        addAllButton.textContent = originalLabel || getWishlistCopy("addAllToCart");
      });
  }

  function handleVariantChanged(event) {
    var detail = event.detail || {};
    var variant = detail.variant;
    if (!variant || !variant.id) return;

    var scope = event.target && event.target.closest
      ? event.target.closest(".product-item, .product-block-list, .product-form, [data-section-type='product']")
      : null;
    var buttons = scope
      ? scope.querySelectorAll("[data-wishlist-context='product']")
      : document.querySelectorAll("[data-wishlist-context='product']");

    buttons.forEach(function (button) {
      var buttonScope = button.closest(".product-item, .product-block-list, .product-form, [data-section-type='product']")
        || scope
        || document;

      button.setAttribute("data-wishlist-variant-id", String(variant.id));
      button.setAttribute(
        "data-wishlist-sku",
        variant.sku ? String(variant.sku) : ""
      );
      button.setAttribute(
        "data-wishlist-variant-title",
        variant.title && variant.title !== "Default Title" ? String(variant.title) : ""
      );
      button.setAttribute(
        "data-wishlist-option-value",
        variant.option1 && variant.option1 !== "Default Title" ? String(variant.option1) : ""
      );
      button.setAttribute(
        "data-wishlist-option-value-1",
        variant.option1 && variant.option1 !== "Default Title" ? String(variant.option1) : ""
      );
      button.setAttribute(
        "data-wishlist-option-value-2",
        variant.option2 && variant.option2 !== "Default Title" ? String(variant.option2) : ""
      );
      button.setAttribute(
        "data-wishlist-option-value-3",
        variant.option3 && variant.option3 !== "Default Title" ? String(variant.option3) : ""
      );
      button.setAttribute(
        "data-wishlist-price",
        getWishlistPriceText(buttonScope, variant)
      );
      button.setAttribute(
        "data-wishlist-image",
        getWishlistProductImage(buttonScope, variant)
      );
    });

    updateButtons();
  }

  function initWishlist() {
    if (initialized) return;
    initialized = true;

    document.addEventListener("click", handleWishlistClick);
    document.addEventListener("click", handleRemoveClick);
    document.addEventListener("click", handleAddAllToCart);
    document.addEventListener("submit", handleGuestWishlistFormSubmit);
    document.addEventListener("variant:changed", handleVariantChanged);

    syncWishlistStateFromRoot();
    if (supportsStorage()) {
      window.addEventListener("storage", function (event) {
        if (event.key === STORAGE_KEY) {
          updateButtons();
          renderGuestWishlistPage();
        }
      });
    }

    updateButtons();
    renderGuestWishlistPage();
    syncSharedWishlistMetaTitle();
    window.requestAnimationFrame(syncSharedWishlistMetaTitle);
    window.setTimeout(syncSharedWishlistMetaTitle, 250);
    window.setTimeout(syncSharedWishlistMetaTitle, 1000);
    window.addEventListener("load", syncSharedWishlistMetaTitle);
    loadState();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initWishlist);
  } else {
    initWishlist();
  }
})();

//When dom is ready
document.addEventListener("DOMContentLoaded", function () {

  // Helper function to get the visible header element
  function getVisibleHeader() {
    var headers = document.querySelectorAll('[data-section-type="header"]');
    for (var i = 0; i < headers.length; i++) {
      var section = headers[i];
      // Check if section is visible (not hidden and has height)
      if (!section.hasAttribute('hidden') &&
          section.style.display !== 'none' &&
          section.offsetHeight > 0) {
        return section.querySelector('.header');
      }
    }
    // Fallback to first header if none found
    return document.querySelector('.header');
  }

  // Helper function to get visible header filler
  function getVisibleHeaderFiller() {
    var headers = document.querySelectorAll('[data-section-type="header"]');
    for (var i = 0; i < headers.length; i++) {
      var section = headers[i];
      if (!section.hasAttribute('hidden') &&
          section.style.display !== 'none' &&
          section.offsetHeight > 0) {
        return section.querySelector('.header--filler');
      }
    }
    return document.querySelector('.header--filler');
  }

  // Fix for sticky header with preset system:
  // Override the --header-height CSS variable to use only the visible header
  function updateHeaderHeight() {
    var visibleHeaderSection = null;
    var headers = document.querySelectorAll('[data-section-type="header"]');
    for (var i = 0; i < headers.length; i++) {
      var section = headers[i];
      if (!section.hasAttribute('hidden') &&
          section.style.display !== 'none' &&
          section.offsetHeight > 0) {
        visibleHeaderSection = section;
        break;
      }
    }
    if (visibleHeaderSection && visibleHeaderSection.parentNode) {
      document.documentElement.style.setProperty(
        '--header-height',
        visibleHeaderSection.parentNode.clientHeight + 'px'
      );
    }
  }

  // Update header height on load and resize
  updateHeaderHeight();
  window.addEventListener('resize', updateHeaderHeight);

  // Also update after a short delay to catch any async preset switching
  setTimeout(updateHeaderHeight, 100);
  setTimeout(updateHeaderHeight, 500);

  // Removed subheader-related code
  var collection_toolbar = document.querySelector(".collection__toolbar");
  //Detect when user scroll down
  document.addEventListener("scroll", function () {
    var scroll = document.documentElement.scrollTop;
    var header = getVisibleHeader();
    var headerFiller = getVisibleHeaderFiller();

    if (!header) return;

    if (scroll < 250 && scroll > 100) {
      header.classList.add("initial-navbar-scroll");
      if (headerFiller) headerFiller.style.height = " 64px";
    } else if (scroll > 250) {
      header.classList.add("navbar-scroll");
      var menu = header.querySelectorAll(".nav-bar__item");
      if (menu.length > 0) {
        for (var i = 0; i < menu.length; i++) {
          menu[i].classList.remove("is-dropdown-open");
          var megaMenu = menu[i].querySelector(".mega-menu");
          if (megaMenu) {
            megaMenu.setAttribute("aria-hidden", "true");
          }
          var navLink = menu[i].querySelector(".nav-bar__link");
          if (navLink) {
            navLink.setAttribute("aria-expanded", "false");
          }
        }
      }
    } else {
      header.classList.remove("navbar-scroll");
      header.classList.remove("initial-navbar-scroll");
      collection_toolbar && collection_toolbar.classList.remove("stick-header");
      if (headerFiller) headerFiller.style.height = " auto";
    }
  });

  // Detect when user scroll up without reach top
  var lastScrollTop = 0;
  window.addEventListener(
    "scroll",
    function () {
      var st = window.pageYOffset || document.documentElement.scrollTop;
      var header = getVisibleHeader();

      if (!header) return;

      if (st > lastScrollTop) {
        header.classList.remove("show");
        collection_toolbar &&
          collection_toolbar.classList.remove("stick-header");
      } else {
        header.classList.add("show");
        if (header.classList.contains("navbar-scroll")) {
          collection_toolbar &&
            collection_toolbar.classList.add("stick-header");
        }
      }
      lastScrollTop = st <= 0 ? 0 : st;
    },
    false
  );



});

(function () {
  if (window.location.pathname !== "/pages/custom/artwork-requirements") {
    return;
  }

  function updateArtworkRequirementHours() {
    if (!document.body) {
      return;
    }

    var walker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT
    );
    var node;

    while ((node = walker.nextNode())) {
      if (node.nodeValue.indexOf("Mon-Fri / 6am-4:30pm PT") !== -1) {
        node.nodeValue = node.nodeValue.replace(
          "Mon-Fri / 6am-4:30pm PT",
          "Mon-Fri / 9am-7:30pm ET"
        );
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", updateArtworkRequirementHours);
  } else {
    updateArtworkRequirementHours();
  }
})();

